export const en = {
  translation: {
    // WebChat
    chat_with_provider: 'Chat with provider',
    //Main Menu

    menu_messages: 'Messages',
    menu_household: 'Household',
    menu_my_profile: 'Medical profile',
    menu_settings: 'Settings',
    menu_log_out: 'Logout',

    // Register Section

    register_title2: "Let's Get Started",
    register_subtitle2:
      'We collect your name and birth date to verify your identity and ensure the security of your personal information.',
    register_agree: 'By signing up, I accept the Tap Telehealth',
    register_terms: 'Terms of Use',
    register_privacy: 'Privacy Policy',
    register_and: 'and acknowledge the',
    register_newsletter: 'I want to receive TapTelehealth newsletter.',
    register_continue_button: 'Continue',
    register_have_already: 'Already have an account?',
    continue_with_google: 'Continue with Google',
    or: 'OR',

    // Login Section
    log_in_account_question: "Don't have an account yet?",
    log_in_sign_up: 'Sign Up',

    // Home Dashboard

    welcome: 'Welcome to Tap Telehealth! Below are some next steps to help us better treat you and your household.',
    hello: 'Hello',
    need_med_care_title: 'Need medical care?',
    need_med_care_text: 'Instantly text one of our providers right now for any non-<br/> emergency healthcare needs.',
    text_doctor_button: 'Text a doctor now',
    complete_profile_title: 'Complete your Medical Profile',
    complete_profile_description:
      'Set up your medical profile to make your future care smoother, quicker, and more personalized when you text us.',
    start_button: 'Start',

    //Quick Access

    quick_access_title: 'Quick access',
    quick_access_1_title: 'Manage your household',
    quick_access_1_text:
      'Easily add family members and complete their medical profiles to make sure they’re ready for seamless care when they need it.',
    quick_access_1_cta: 'Manage household',

    quick_access_2_title: 'Look back',
    quick_access_2_text:
      'Easily access past sessions, prescriptions, referrals, excuse notes, and more in one convenient place.',
    quick_access_2_cta: 'View history',

    quick_access_3_title: 'Learn more',
    quick_access_3_text: 'Find out more about TapTelehealth and the many ways we can support your health journey.',
    quick_access_3_cta: 'Learn more about Tap Telehealth',

    // Menu additions
    menu_home: 'Home',
    drawer_menu_title: 'Menu',
    menu_open: 'Open menu',
    time_2_min: '2min',

    // Alts and misc
    alt_logo: 'Logo',
    alt_profile_icon: 'Profile icon',
    time_8_min: '8min',

    //Household

    household_title: 'Household',
    household_add_pharmacy_banner_title: 'Add preferred pharmacy',
    household_add_pharmacy_banner_description:
      'Share your preferred pharmacy information to help us send prescriptions to the location most convenient for you.',
    household_add_pharmacy_banner_cta: 'START',
    household_s_member: 'household member',
    household_members: 'Household Members',
    household_add: 'Add',
    household_member: 'Minor',
    household_preferred_pharmacies_title: 'Preferred pharmacy',
    household_owner: 'Household Owner',
    self: 'Self',
    address_not_available: 'Address not available',
    before_change_address_title: 'Before you change your address',
    before_change_address_body:
      'Updating your address will apply to all members of your household. If you want to change your address only for yourself, you must first leave this household.',
    leave_this_household: 'Leave this household',
    change_address_for_everyone: 'Change address for everyone',
    change_your_address_title: 'Change your address',
    household_add_member_rights_notice:
      'By adding a child to your household, you confirm that you have the legal right to manage their medical and other personal information. This includes acting as their parent, legal guardian, or authorised representative.',
    household_added_to_your_household: '{{name}} was added to your household!',
    household_add_another_member: 'Add another household member',

    //Settings

    settings_title: 'Settings',
    settings_smenu_login_security: 'Login & Security',
    settings_smenu_household: 'Manage Household',
    settings_smenu_billing: 'Billing',
    settings_smenu_notifications_privacy: 'Notifications & Privacy',
    settings_email_preferences_card_title: 'Email Preferences',
    settings_email_preferences_card_subtitle: 'Updates & Offers',
    settings_email_preferences_card_description: 'Receive updates about our services, special offers, and health tips.',
    settings_sms_preferences_card_title: 'SMS Messages',
    settings_sms_preferences_card_subtitle: 'General health information and service related updates',
    settings_sms_preferences_card_description:
      'Turn this on if you want to get text messages from Tap TeleHealth about public health reminders, service updates, and educational content. Message and data rates may apply. You can change your preferences at any time. These messages are optional and are not required to use Tap Telehealth Services.',
    settings_privacy_card_title: 'Privacy',
    settings_privacy_card_subtitle: 'Privacy Agreement (HIPAA)',
    settings_privacy_card_description:
      'I understand that Tap Telehealth may not be fully HIPAA compliant. By using this service, I accept any associated risks and consent to the use of my health information as needed for telehealth services.',
    settings_privacy_card_subtitle2: 'Terms of Use',
    settings_privacy_card_description2:
      'Understand the terms that govern your use of our platform and services to ensure compliance and transparency.',
    settings_privacy_card_terms_link: 'Read Terms of Use',
    settings_privacy_card_subtitle3: 'Privacy Policy',
    settings_privacy_card_description3:
      'Learn how we collect, use, and protect your personal information, and understand your privacy rights.',
    settings_privacy_card_policy_link: 'Read Privacy Policy',

    settings_billing_card_title: 'Billing',
    settings_billing_card_subtitle:
      'Your TapTelehealth service is conveniently billed through your utility provider, making it simple and hassle-free to stay connected to quality healthcare.',
    settings_billing_card_subtitle2:
      'If you are no longer interested in taking advantage of this service, learn how to opt out by clicking the link below.',
    settings_billing_card_cta: 'Learn more',

    settings_account_deletion_card_title: 'Account Deletion',
    settings_account_deletion_card_description:
      'By deleting your account, all your medical records, past session information, minor profiles, and associated data will be permanently removed. This action cannot be undone.',
    settings_account_deletion_card_subtitle: 'Account',
    settings_account_deletion_card_cta: 'Delete',

    //Footer
    footer_contact: 'CONTACT',
    footer_how_it_works: 'How It Works',
    footer_what_we_treat: 'What We Treat',
    footer_about: 'About',
    footer_blog: 'Blog',
    footer_partner: 'Partner with us',

    // Miscellaneous
    back: 'Back',
    edit: 'Edit',
    cancel: 'Cancel',
    update: 'Update',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    done: 'Done',
    next: 'Next',
    continue: 'Continue',
    skip_for_now: 'Skip for now',
    search: 'Search',
    add: 'Add',
    added: 'Added',
    miles: 'miles',
    yes_remove: 'Yes, remove',
    yes_add: 'Yes, add {{item}}',
    loading: 'Loading',
    yes: 'Yes',
    no: 'No',
    na: 'N/A',
    unknown: 'Unknown',
    are_you_sure: 'Are you sure?',
    remove_household_member_confirm: 'Do you want to remove this household member?',
    remove_pharmacy_confirm:
      "Are you sure you want to remove this pharmacy from your household's list of preferred pharmacies?",
    please_enter_first_name: 'Please enter first name',
    please_enter_middle_name: 'Please enter middle name (if applicable)',
    please_enter_last_name: 'Please enter last name',
    must_be_younger_18: 'Must be younger than 18 years old',
    must_be_18_or_older: 'You must be 18 or older',

    // Demographics Module
    terms_of_use: 'Terms of Use',
    privacy_policy: 'Privacy Policy',
    and: 'and',
    sign_up: 'Sign up',

    demographics_setup_title: "Let's get you set up!",
    demographics_first_name: 'First Name',
    demographics_middle_name: 'Middle Name',
    demographics_last_name: 'Last Name',
    demographics_full_name: 'Full Name',
    demographics_email: 'Email address',
    demographics_dob: 'Date of birth',
    demographics_dob_placeholder: 'MM/DD/YYYY',
    demographics_gender: 'Gender',
    demographics_gender_male: 'Male',
    demographics_gender_female: 'Female',
    demographics_gender_other: 'Other',
    demographics_gender_unknown: 'Unknown',
    demographics_street_address: 'Street Address',
    demographics_address_line_2: 'Address Line 2',
    demographics_city: 'City',
    demographics_zip_code: 'ZIP code',
    demographics_state: 'State',
    demographics_current_state: "State you're currently in",
    demographics_address: 'Address',
    demographics_use_current_location: 'Use my current location',
    demographics_continue: 'Continue',
    demographics_error_current_location: 'Failed to get your current location',
    demographics_add_address_manually: 'Add manually',

    demographics_consent_title: 'Just a quick consent check',
    demographics_consent_body_line1:
      'Texting, like phone calls and voicemails, may not always be 100% secure depending on your mobile service. You can review our <a>Texting Privacy Practices</a> for more details.',
    demographics_consent_body_line2:
      'Your care today will be provided through telehealth (text, phone, or video) instead of in-person. The risks, benefits, and alternatives—including your right to stop at any time and seek in-person care—have been explained. Your privacy is protected by law, though no system is completely secure.',
    demographics_consent_body_line3: 'Do you consent to communicate by text and to receive care by telehealth today?',
    demographics_consent_agree: 'I agree',
    demographics_consent_disagree: 'I disagree',
    demographics_consent_footer_prefix: 'You can read our',
    demographics_consent_footer_suffix: 'for more details.',

    demographics_confirm_title: 'Confirm your personal information',

    // Demographics - Minor
    demographics_minor_title: 'Minor information',
    demographics_minor_address_notice:
      'We can only register a minor at the same address where their parent or legal guardian currently lives.',
    demographics_minor_success_body: 'You can now return to your chat with your Tap Telehealth provider.',

    demographics_no_consent_title: 'No problem!',
    demographics_no_consent_body_line1:
      'Thank you for letting us know. If you prefer not to communicate by text, you can still receive care today through our HIPAA-compliant Patient Portal.',
    demographics_no_consent_body_line2: 'Your care will still be provided by telehealth instead of in-person.',
    demographics_no_consent_body_line3:
      'Do you consent to receive care by telehealth today through the Patient Portal?',
    demographics_no_consent_agree_portal_cta: 'I agree, go to Patient Portal',

    demographics_lastword_title: 'We respect your choice!',
    demographics_lastword_body_line1:
      'We understand and respect your choice. At this time, Tap Telehealth can only provide care through telehealth (text, phone, or video). Unfortunately, we’re not able to offer in-person or alternative services today.',
    demographics_lastword_body_line2:
      'If you’d like, you can always reach back out when telehealth works for you. In the meantime, if you need urgent medical attention, please call 911 or go to your nearest emergency room.',

    demographics_success_title: 'You’re all set!',
    demographics_success_body:
      'Thanks for completing your info. You can now return to your chat with your Tap Telehealth provider — they’re ready to help. Please let them know that you completed this form.',
    demographics_back_to_chat: 'Back to Chat',

    // Intake
    intake_closed_title: 'This form is no longer available',
    intake_closed_body: 'Your provider will collect your details in the chat.',
    intake_who_title: 'Who needs care today?',
    intake_who_self: 'Me',
    intake_who_self_description: "I'm the patient",
    intake_who_child: 'My child',
    intake_who_child_description: "I'm a parent or legal guardian and will add my child",
    intake_under_18_link: "I'm under 18",
    intake_under_18_notice:
      'We can only provide care to patients under 18 together with a parent or legal guardian. Please ask your parent or guardian to continue this form with you, or have them text us from their own phone.',
    intake_under_18_confirm: 'I understand',
    intake_minor_success_title: 'Thanks for letting us know',
    intake_minor_success_body:
      'Please have your parent or guardian nearby. A provider will reach out in your text conversation shortly.',
    intake_stepper_guardian: 'Parent or guardian (you)',
    intake_stepper_child: 'Your child',
    intake_guardian_title: 'First, tell us about yourself',
    intake_guardian_notice:
      "Step 1 is about you. As the parent or legal guardian you are the account holder. You'll add your child on the next step.",
    intake_children_title: 'Now, about your child',
    intake_children_intro:
      'Your child will share your phone number and home address. Consent you gave applies on their behalf. The visit will be for your child.',
    intake_child_heading: 'Child {{number}}',
    intake_child_born: 'born {{dob}}',
    intake_remove_child: 'Remove',
    intake_add_child: 'Add another child',
    intake_visit_for_title: 'Which child is this visit for?',
    intake_visit_for_required: 'Please choose who this visit is for',
    intake_confirm_children: 'Children',
    intake_confirm_visit_for: 'This visit is for',
    intake_confirm_patient: 'Patient',
    intake_confirm_guardian: 'Parent or Guardian',
    intake_confirm_children_consent:
      'As the parent or legal guardian, your consents above also apply to the children you added.',
    intake_email_in_use: 'This email is already in use. Leave it empty or enter another one.',
    intake_success_body: 'Head back to your text conversation — a provider will be with you shortly.',
    intake_adult_dob_child_hint:
      "You must be 18 or older. This form is about you as the adult contacting us. If you're reaching out about your child, keep your own details here and add your child on the next step.",

    // Demographics validation
    demographics_validation_first_name_required: 'First name is required',
    demographics_validation_last_name_required: 'Last name is required',
    demographics_validation_email_invalid: 'Please enter a valid email address',
    demographics_validation_dob_required: 'Date of birth is required',
    demographics_validation_dob_format: 'Please enter date in MM/DD/YYYY format',
    demographics_validation_dob_month: 'Please enter a valid month',
    demographics_validation_dob_day: 'Please enter a valid day',
    demographics_validation_dob_year: 'Please enter a valid year',
    demographics_validation_dob_future: 'Date of birth cannot be in the future',
    demographics_validation_dob_valid: 'Please enter a valid date',
    demographics_validation_gender_required: 'Please select a gender',
    demographics_validation_phone_required: 'Phone number is required',
    demographics_phone: 'Phone number',
    validation_numbers_only: 'Only numbers are allowed!',
    demographics_validation_address_required: 'Address is required',
    demographics_validation_city_required: 'City is required',
    demographics_validation_zip_required: 'ZIP code is required',
    demographics_validation_state_required: 'State is required',
    demographics_validation_address_select: 'Please select an address from the suggestions',
    demographics_address_placeholder: 'Start typing your address...',
    demographics_heard_about_service_label: 'How did you first learn about our service?',
    demographics_heard_about_service_other: 'Other (please specify)',
    demographics_heard_about_service_friend: 'A friend or family member',
    demographics_heard_about_service_community: 'Community events',
    demographics_heard_about_service_social: 'Social media',
    demographics_heard_about_service_google: 'Google',
    demographics_heard_about_service_specify: 'Please specify how you heard about our service',

    // Patient Portal - Medical History page and related components
    medical_history_title: 'Medical History',
    medical_history_description:
      'Keep track of your medical history here, ensuring we always have the latest details to provide the most effective care.',
    medical_history_pdf_filename: 'MedicalHistory.pdf',

    title_section_download_pdf: 'Download (PDF)',
    title_section_see_chat: 'See chat',

    sidebar_medical_history: 'Medical History',
    sidebar_personal_info: 'Personal Information',
    personal_info_general_title: 'General Information',

    // Past Sessions
    no_sessions_available: 'No sessions available',
    no_diagnosis_available: 'No diagnosis available',
    past_session_label: 'Past Session',
    end_of_chat_title: 'End of chat',
    encounter_closed_message: 'This encounter is closed. If you need further assistance, please connect with a doctor.',
    connect_me_with_doctor: 'Connect me with a doctor',
    handouts_title: 'Handouts',
    additional_notes: 'Additional Notes',
    no_files_available: 'No files available',
    excuse_notes_title: 'Excuse Notes',
    excuse_note_title_work: 'Work excuse note',
    excuse_note_title_school: 'School excuse note',
    excuse_note_title_other: 'Excuse note',
    excuse_note_open_error: "We couldn't open this excuse note. Please try again.",
    no_excuse_notes_available: 'No excuse notes available',
    prescriptions_title: 'Prescriptions',
    no_prescriptions_available: 'No prescriptions available',
    referrals_title: 'Referrals',
    no_referrals_available: 'No referrals available',
    summary_title: 'Summary',
    no_data: 'No data',
    no_data_available: 'No data available',
    no_date_available: 'No Date Available',

    // Footer brand heading
    footer_brand_heading: 'TAP TELEHEALTH',

    // Medical History - Allergies Card
    mh_allergies_title: 'Allergies',
    mh_allergies_intro: 'Knowing your allergies helps us provide more accurate prescriptions and prevent reactions.',
    mh_allergies_yesno_question: 'Do you have any allergies (drug, food, etc.)?',
    mh_allergies_none_label: 'No known allergies',
    mh_allergies_add_btn: 'Add allergy',
    mh_allergies_none_cta: 'I don’t have any allergies',
    mh_allergies_form_name_label: 'Name',
    mh_allergies_form_name_required: 'Please select the allergy',
    mh_allergies_form_reaction_label: 'Reaction',
    mh_allergies_reaction_prefix: 'Reaction',

    // Medical History - Medications Card
    mh_medications_title: 'Medications',
    mh_medications_intro: 'Knowing your current medications helps us prevent interactions and provide safer care.',
    mh_medications_yesno_question:
      'Do you currently take any medication on a regular basis for managing any health conditions?',
    mh_medications_none_label: 'No current medications',
    mh_medications_add_btn: 'Add medication',
    mh_medications_none_cta: 'I don’t take any medication on a regular basis',
    mh_medications_form_drug_label: 'Drug Name',
    mh_medications_form_drug_required: 'Please select the medication',
    mh_medications_form_dosage_label: 'Dosage',
    mh_medications_form_dosage_required: 'Please enter the dosage',
    mh_medications_form_dosage_placeholder: 'Search drug first to change dosage.',
    mh_medications_form_frequency_label: 'Frequency',

    // Medical History - Measurements Card
    mh_measurements_title: 'Measurements',
    mh_measurements_intro: 'Providing your weight and height helps us tailor treatments and dosages to your needs.',
    mh_measurements_height_label: 'What is your height?',
    mh_measurements_height_feet_required: 'Please enter feet',
    mh_measurements_height_feet_placeholder: 'ft',
    mh_measurements_height_inches_placeholder: 'in',
    mh_measurements_weight_label: 'What is your weight?',
    mh_measurements_weight_required: 'Please enter weight',
    mh_measurements_weight_placeholder: 'lbs',
    mh_measurements_view_height: 'Height',
    mh_measurements_view_weight: 'Weight',

    // Medical History - Health Problems Card
    mh_healthproblems_title: 'Health problems',
    mh_healthproblems_intro:
      'Sharing your medical history helps us understand your health better and provide more personalized care.',
    mh_healthproblems_none_label: 'No known health problems',
    mh_healthproblems_add_btn: 'Add health problem',
    mh_healthproblems_none_cta: 'I don’t have any health problems',
    mh_healthproblems_other_placeholder: 'Please specify...',

    // Medical History - Family History Card
    mh_familyhistory_title: 'Family History',
    mh_familyhistory_intro:
      'Understanding your family medical history helps us assess your health risks and provide proactive care.',
    mh_familyhistory_yesno_question:
      'Do any of your family members have long-term health conditions (such as diabetes, heart disease, or other chronic conditions)?',
    mh_familyhistory_none_label: 'No known family problems',
    mh_familyhistory_add_btn: 'Add family history',
    mh_familyhistory_none_cta: 'No one in my family has any long-term health conditions',
    mh_familyhistory_other_placeholder: 'Please specify...',

    // Medical History - Lifestyle Card
    mh_lifestyle_title: 'Lifestyle',
    mh_lifestyle_intro: 'Knowing about your lifestyle helps us understand factors that impact your health and care.',
    mh_lifestyle_smoking_question:
      'Do you currently smoke or vape any substances (e.g., cigarettes, e-cigarettes, or other vaping products)?',
    mh_lifestyle_yes_smoke: 'Yes, I smoke',
    mh_lifestyle_yes_vape: 'Yes, I vape',
    mh_lifestyle_yes_both: 'Yes, I both smoke and vape',
    mh_lifestyle_drinking_question: 'Do you drink alcohol?',
    mh_lifestyle_view_smoking_label: 'Smoking/Vaping',
    mh_lifestyle_view_drinking_label: 'Drinking alcohol',
    mh_lifestyle_no_response: 'No response',

    // Medical History - Surgical History Card
    mh_surgical_title: 'Surgical History',
    mh_surgical_intro: 'Knowing your surgical history helps us avoid complications and ensure safer treatment.',
    mh_surgical_yesno_question: 'Have you had any surgeries in the past?',
    mh_surgical_none_label: 'No surgeries',
    mh_surgical_add_btn: 'Add surgery',
    mh_surgical_none_cta: 'I haven’t had any surgeries in the past',
    mh_surgical_form_surgery_label: 'Surgery',
    mh_surgical_form_surgery_required: 'Please select an option',
    // Patient Portal - Emergency Contacts
    emergency_contacts_title: 'Emergency Contacts',
    emergency_contacts_intro:
      'Please add the contact details of individuals you permit us to contact in case of an emergency.',
    emergency_contacts_add_btn: 'Add emergency contact',
    relationship: 'Relationship',
    validation_select_option: 'Select an option',

    // Relationship types (from RelationshipType enum)
    relationship_type_emergency_contact: 'Emergency contact',
    relationship_type_guardian: 'Guardian',
    relationship_type_next_of_kin: 'Next of kin',
    relationship_type_caregiver: 'Caregiver',
    relationship_type_parent: 'Parent',
    relationship_type_child: 'Child',
    relationship_type_spouse: 'Spouse',
    relationship_type_sibling: 'Sibling',
    relationship_type_mother: 'Mother',
    relationship_type_father: 'Father',
    relationship_type_son: 'Son',
    relationship_type_daughter: 'Daughter',
    relationship_type_grandmother: 'Grandmother',
    relationship_type_grandfather: 'Grandfather',
    relationship_type_granddaughter: 'Granddaughter',
    relationship_type_grandson: 'Grandson',
    relationship_type_aunt: 'Aunt',
    relationship_type_uncle: 'Uncle',
    relationship_type_niece: 'Niece',
    relationship_type_nephew: 'Nephew',
    relationship_type_cousin: 'Cousin',
    relationship_type_legal_guardian: 'Legal guardian',
    relationship_type_foster_parent: 'Foster parent',
    relationship_type_adoptive_parent: 'Adoptive parent',
    relationship_type_step_parent: 'Step parent',
    relationship_type_step_son: 'Step son',
    relationship_type_step_daughter: 'Step daughter',
    relationship_type_foster_son: 'Foster son',
    relationship_type_foster_daughter: 'Foster daughter',
    relationship_type_step_sibling: 'Step sibling',
    relationship_type_in_law: 'In-law',
    relationship_type_domestic_partner: 'Domestic partner',
    relationship_type_lawyer: 'Lawyer',
    relationship_type_doctor: 'Doctor',
    relationship_type_therapist: 'Therapist',
    relationship_type_social_worker: 'Social worker',
    relationship_type_case_manager: 'Case manager',
    relationship_type_nurse: 'Nurse',
    relationship_type_neighbor: 'Neighbor',
    relationship_type_coworker: 'Coworker',
    relationship_type_roommate: 'Roommate',
    relationship_type_mentor: 'Mentor',
    relationship_type_mentee: 'Mentee',
    relationship_type_religious_leader: 'Religious leader',
    relationship_type_volunteer: 'Volunteer',
    relationship_type_colleague: 'Colleague',
    relationship_type_supervisor: 'Supervisor',
    relationship_type_subordinate: 'Subordinate',
    relationship_type_godparent: 'Godparent',
    relationship_type_godchild: 'Godchild',
    relationship_type_ward: 'Ward',
    relationship_type_sponsor: 'Sponsor',
    relationship_type_benefactor: 'Benefactor',
    relationship_type_friend: 'Friend',
    relationship_type_acquaintance: 'Acquaintance',
    relationship_type_partner: 'Partner',
    relationship_type_other: 'Other',

    // Minor Guardian Relationship translations
    minor_guardian_relationship_mother: 'Mother',
    minor_guardian_relationship_father: 'Father',
    minor_guardian_relationship_aunt: 'Aunt',
    minor_guardian_relationship_uncle: 'Uncle',
    minor_guardian_relationship_grandmother: 'Grandmother',
    minor_guardian_relationship_grandfather: 'Grandfather',
    minor_guardian_relationship_son: 'Son',
    minor_guardian_relationship_daughter: 'Daughter',
    minor_guardian_relationship_step_son: 'Step son',
    minor_guardian_relationship_step_daughter: 'Step daughter',
    minor_guardian_relationship_step_mother: 'Step mother',
    minor_guardian_relationship_step_father: 'Step father',
    minor_guardian_relationship_foster_son: 'Foster son',
    minor_guardian_relationship_foster_daughter: 'Foster daughter',
    minor_guardian_relationship_foster_mother: 'Foster mother',
    minor_guardian_relationship_foster_father: 'Foster father',
    minor_guardian_relationship_ward: 'Ward',
    minor_guardian_relationship_grandson: 'Grandson',
    minor_guardian_relationship_granddaughter: 'Granddaughter',
    minor_guardian_relationship_niece: 'Niece',
    minor_guardian_relationship_nephew: 'Nephew',
    minor_guardian_relationship_cousin: 'Cousin',
    minor_guardian_relationship_other: 'Other',

    // Patient Portal - Pharmacy Step
    pharmacy_search_label: 'Search pharmacy',
    pharmacy_search_placeholder: 'Search by name, address or ZIP code',

    // Stepper - Comple        ButtonText='Go back to homepage'tion messages
    stepper_finish_title: 'All done!',
    stepper_finish_btn_home: 'Go back to homepage',
    stepper_finish_desc:
      'We appreciate your time and effort in sharing your information. This helps us provide safe, personalized care and prioritize your health.',
    stepper_close_btn: 'Close',
    stepper_thankyou_title: 'Thank You!',
    stepper_finish_description:
      'Your information has been successfully submitted. Please return to the chat with your provider to continue the conversation and receive further guidance.',
    mh_surgical_form_other_label: 'Specify Other Surgery',
    mh_surgical_form_other_required: 'Please specify the surgery',
    mh_surgical_form_other_placeholder: 'Enter surgery name',

    // Medical History - PDF
    pdf_medical_history_title: 'MEDICAL HISTORY',
    pdf_label_gender: 'Gender',
    pdf_label_dob: 'Date of Birth',
    pdf_label_height: 'Height',
    pdf_label_weight: 'Weight',
    pdf_label_office: 'Office',
    pdf_label_website: 'Website',
    pdf_label_email: 'Email',
    pdf_past_sessions_title: 'PAST SESSIONS',
    // Auth - Recover Password
    email_required: 'Please enter your email',
    unknown_error_try_again: 'Unknown error, please try again later.',

    // Auth - Send Code / Enter Code / Send Mail
    sendcode_title: 'Your Direct Line to Care',
    sendcode_description:
      'Enter your mobile phone number to receive an SMS verification code. Carrier charges may apply.',
    need_assistance: 'Need assistance?',
    reach_out_at: 'Reach out to us at',
    read_prefix: 'Read TapTelehealth',
    terms_and_conditions: 'Terms & Conditions',
    enter_code_title: 'Enter Your Code',
    enter_code_phone_sent: 'We’ve sent a code to your phone ending in',
    enter_code_email_sent: 'We’ve sent a code to your email address',
    enter_code_enter_below: 'Enter it below to verify your account.',
    enter_code_send_new: 'Send New Code',
    enter_code_required: 'Please enter the verification code',
    enter_code_must_be_6_digits: 'The code must be exactly 6 digits',
    verify_cta: 'Verify',
    send_code_cta: 'Send Code',
    mobile_phone_number_label: 'Mobile Phone Number',
    must_agree_to_continue: 'You must agree to continue',
    messaging_consent_text:
      'I consent to receive SMS messages from Tap Telehealth about general health information and service related updates. I understand that message and data rates may apply and that message frequency varies. I can unsubscribe at any time through the <portalLink>Tap Telehealth Patient Portal</portalLink> or by replying STOP to any message. Learn more in our <termsLink>Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>, or by replying HELP to any message.',
    email_consent_text: 'I agree to receive health related information and updates by email.',

    // Auth - Household
    household_where_located_title: 'Where Are You Located?',
    household_where_located_desc:
      'Providing your address ensures we can connect you to the right healthcare provider quickly and easily.',

    // Survey Module - Survey Steps
    survey_info_title: 'Help Us Personalize Your Care',
    survey_info_button: 'Start',
    survey_info_description_part1:
      "Before we complete your prescription, we'd like to gather some important health details. This quick questionnaire",
    survey_info_description_part2: 'helps us ensure your safety and provide the best care',
    survey_all_done_description:
      'Your information has been successfully submitted. Please return to the chat with your clinician to continue the conversation and receive further guidance.',

    // Survey Module - Allergies Card
    survey_allergies_title: 'Allergies',
    survey_allergies_title_minor: 'Allergies of a Minor',
    survey_allergies_question: 'Do you have any allergies (drug, food, etc.)?',
    survey_allergies_question_minor: 'Does your minor have any allergies (drug, food, etc.)?',
    survey_allergies_intro:
      'Sharing your allergy information ensures safer prescriptions and helps us avoid adverse reactions.',
    survey_allergies_intro_minor:
      'Sharing this allergy information ensures safer prescriptions and helps us avoid adverse reactions.',
    survey_allergies_no_cta: "No, I don't have any allergies",
    survey_allergies_no_cta_minor: "No, the minor doesn't have any allergies",
    survey_allergies_yes_add: 'Yes, add allergy',
    survey_allergies_form_name_label: 'Allergy name',
    survey_allergies_form_name_required: 'Please select the allergy',
    survey_allergies_form_reaction_label: 'Reaction (Select all that apply):',
    survey_allergies_form_other_placeholder: 'Please specify',
    survey_allergies_form_other_required: 'Please specify the reaction',
    survey_allergies_add_btn: 'Add allergy',
    survey_allergies_confirm_question: 'Is this allergy information correct and complete?',
    survey_allergies_no_update: 'No, I need to add allergy',
    survey_allergies_reaction_rash: 'Rash/Hives',
    survey_allergies_reaction_swelling: 'Swelling',
    survey_allergies_reaction_breathing: 'Difficulty breathing',
    survey_allergies_reaction_anaphylaxis: 'Anaphylaxis',
    survey_allergies_reaction_gastro: 'Gastrointestinal symptoms',
    survey_allergies_reaction_itching: 'Itching',
    survey_allergies_reaction_other: 'Other',

    // Survey Module - Pharmacy Card
    survey_pharmacy_title: 'Select pharmacy',
    survey_pharmacy_search_label: 'Search pharmacy',
    survey_pharmacy_search_placeholder: 'Search by name, address or ZIP code',
    survey_pharmacy_add_btn: '+ Add',
    survey_pharmacy_confirm_question: 'Is this pharmacy correct?',
    survey_pharmacy_no_update: 'No, I need to update my pharmacy',

    // Survey Module - Height Card
    survey_height_title: 'Height',
    survey_height_title_minor: 'Minor height',
    survey_height_label: 'Your height',
    survey_height_label_minor: 'Minor height',
    survey_height_feet_required: 'Please enter feet',
    survey_height_inches_required: 'Please enter inches',

    // Survey Module - Weight Card
    survey_weight_title: 'Weight',
    survey_weight_title_minor: 'Minor weight',
    survey_weight_label: 'Your weight (lbs)',
    survey_weight_label_minor: 'Minor weight (lbs)',

    // Survey Module - First Question
    survey_q1_title: 'Tell us about your healthcare options',
    survey_q1_question: 'Without Tap Telehealth today, how would you have gotten care?',
    survey_q1_instruction: 'Please select what realistically applies to your situation.',
    survey_q1_option1_title: 'No way to get medical care',
    survey_q1_option1_description:
      'Would need to call 911 due to lack of transportation, difficulty driving while sick, or mobility issues.',
    survey_q1_option1_italic: '(Common for many patients)',
    survey_q1_option2_title: 'No immediate care options nearby',
    survey_q1_option2_description:
      'The ER would be my only option for the same-day care due to timing, location, or needing care after-hours.',
    survey_q1_option2_italic: '(Most common situation)',
    survey_q1_option3_title: 'Urgent care available',
    survey_q1_option3_description:
      'Have transportation and could pay $50-145 copay, but would involve 1-2 hour wait time.',
    survey_q1_option4_title: 'My doctor could see me quickly',
    survey_q1_option4_description:
      'Have a PCP who offers same/next-day appointments and symptoms could wait until then.',
    survey_q1_option5_title: 'Would have waited it out',
    survey_q1_option5_description: 'Would have tried self-care at home without seeking professional medical help.',

    // Survey Module - Second Question
    survey_q2_title: 'Time saved',
    survey_q2_info_line1: 'In-person medical visits typically mean:',
    survey_q2_info_line2: '• 3-4 hours for a doctor visit (travel + waiting + appointment)',
    survey_q2_info_line3: '• Most people take a full day off work/school for appointments',
    survey_q2_info_line4: '• Without early treatment, symptoms often last 2-3 days longer',
    survey_q2_question: 'How many work/school days did Tap Telehealth save you?',
    survey_q2_option1: '3+ days (counting both appointment time & faster recovery)',
    survey_q2_option2: '2 days (common when symptoms resolve faster with early treatment)',
    survey_q2_option3: '1 day (typical for a single in-person visit)',
    survey_q2_option4: 'Less than 1 day',
    survey_q2_option5: "Not applicable (don't work/attend school)",

    // Survey Module - Third Question
    survey_q3_title: 'Time saved',
    survey_q3_subtitle: 'Your experience with our service',
    survey_q3_info_line1: 'Telehealth typically saves patients:',
    survey_q3_info_line2: '• 2-4 hours of travel and waiting time',
    survey_q3_info_line3: '• $50-250 in costs',
    survey_q3_info_line4: '• The hassle of arranging transportation',
    survey_q3_slider1_label: 'How likely are you to recommend Tap Telehealth?',
    survey_q3_slider1_min: 'Not likely',
    survey_q3_slider1_max: 'Extremely likely',
    survey_q3_slider2_label: 'How much better was Tap Telehealth than going to an ER or urgent care?',
    survey_q3_slider2_min: 'Not better',
    survey_q3_slider2_max: 'Extremely better',
    survey_q3_slider3_label: 'How easy was it to use Tap Telehealth service?',
    survey_q3_slider3_min: 'Very difficult',
    survey_q3_slider3_max: 'Very easy',
    survey_q3_submit_btn: 'Submit',

    // Survey Module - Fourth Question
    survey_q4_title: 'Coverage',
    survey_q4_info:
      "Your cost is the same no matter how you're covered - we ask only to understand who TAP is reaching. This is optional.",
    survey_q4_question: 'Do you currently have health insurance or Medicaid?',
    survey_q4_option1: 'Private / employer insurance',
    survey_q4_option2: 'Medicaid',
    survey_q4_option3: 'Medicare',
    survey_q4_option4: 'No insurance right now',
    survey_q4_option5: 'Prefer not to say',

    // Survey Module - Additional Feedback
    survey_feedback_title: 'Additional feedback',
    survey_feedback_subtitle:
      'Share anything else about your experience with Tap Telehealth. Your feedback helps us improve our service.',
    survey_feedback_info:
      'Please do not include any personal or medical information in your feedback such as names, contact details or any other information that could identify you.',
    survey_feedback_placeholder: 'Your feedback',
    survey_feedback_consent:
      'I agree that my feedback or review may be shared publicly by Tap Telehealth, such as on our website or social media, without any personal or identifying information.',
    survey_feedback_submit_btn: 'Submit',

    // Survey Module - Savings Card
    survey_savings_title: "Here's your visit, by the numbers.",
    survey_savings_subtitle: 'A conservative estimate of what today would have cost you elsewhere.',

    // Survey Module - Advocate
    survey_thank_you_title: 'Thank you - this really helps',
    survey_thank_you_text:
      "Your honest feedback is how TAP gets better for you and your neighbors. We've passed it to the care team.",
    survey_advocate_no_medical_care_title: 'You skipped the most expensive door there is.',
    survey_advocate_no_care_options_title: 'You handled with a text what usually costs $1,500 and an afternoon.',
    survey_advocate_urgent_care_title: 'No copay. No waiting room. No afternoon gone.',
    survey_advocate_doctor_quick_title: "You've got a doctor you can reach. A lot of neighbors don't.",
    survey_advocate_waited_out_title: "You didn't wait and see. That matters more than you think.",
    survey_advocate_no_medical_care_text:
      "A text instead of an ambulance and an ER - that's the ~$2,000 hit most families never see coming, and you walked right past it. Now go show the neighbor who feels they have no other option where the door is. That's what makes you one of {{city}}'s best advocates.",
    survey_advocate_no_medical_care_text_no_city:
      "A text instead of an ambulance and an ER - that's the ~$2,000 hit most families never see coming, and you walked right past it. Now go show the neighbor who feels they have no other option where the door is.",
    survey_advocate_no_care_options_text:
      "Most people don't know a text can do that - you do. So tell the neighbor who'd have driven to the ER tonight: a two-minute message would've handled it. That's what makes you one of {{city}}'s best advocates.",
    survey_advocate_no_care_options_text_no_city:
      "Most people don't know a text can do that - you do. So tell the neighbor who'd have driven to the ER tonight: a two-minute message would've handled it.",
    survey_advocate_urgent_care_text:
      "You skipped the ~$115 and the hour in a plastic chair for something a text solved. Multiply that across the neighborhood and it's real money staying in {{city}}. Tell one neighbor - that's what makes you one of its best advocates.",
    survey_advocate_urgent_care_text_no_city:
      'You skipped the ~$115 and the hour in a plastic chair for something a text solved. Tell one neighbor - that is what makes you one of the best advocates.',
    survey_advocate_doctor_quick_text:
      "The ones who don't end up at urgent care or the ER for things a text would've fixed. You can hand them what you already have - point them to the doctor they didn't know they had. That's what makes you one of {{city}}'s best advocates.",
    survey_advocate_doctor_quick_text_no_city:
      "The ones who don't end up at urgent care or the ER for things a text would've fixed. You can hand them what you already have - point them to the doctor they didn't know they had.",
    survey_advocate_waited_out_text:
      "The thing you ignore on Tuesday is the ER trip on Saturday - and you skipped that. Now go tell the neighbor who's still toughing it out: a two-minute text could save them a weekend in the waiting room. That's what makes you one of {{city}}'s best advocates.",
    survey_advocate_waited_out_text_no_city:
      "The thing you ignore on Tuesday is the ER trip on Saturday - and you skipped that. Now go tell the neighbor who's still toughing it out: a two-minute text could save them a weekend in the waiting room.",
    survey_advocate_share_button: 'Share your experience →',

    // Survey Module - Share
    survey_share_title: 'Share the love (and the savings)!',
    survey_share_subtitle: 'One tap - your card and a caption are ready to go.',
    survey_share_caption_heading: 'Your caption',
    survey_share_no_medical_care_caption:
      "Couldn't have gotten to a doctor today - so I texted one and had what I needed in minutes. That's a ~$2,000 ER/ambulance trip I didn't have to take. Wild that more people don't know {{city}} has this. 💙 #ADoctorIsJustATapAway",
    survey_share_no_medical_care_caption_no_city:
      "Couldn't have gotten to a doctor today - so I texted one and had what I needed in minutes. That's a ~$2,000 ER/ambulance trip I didn't have to take. 💙 #ADoctorIsJustATapAway",
    survey_share_no_care_options_caption:
      "Texted a real doctor instead of sitting in the ER tonight - answer and a prescription in about 15 minutes, no $1,500 bill. If you're in {{city}}, you've got this too. 💙 #ADoctorIsJustATapAway",
    survey_share_no_care_options_caption_no_city:
      'Texted a real doctor instead of sitting in the ER tonight - answer and a prescription in about 15 minutes, no $1,500 bill. 💙 #ADoctorIsJustATapAway',
    survey_share_urgent_care_caption:
      'Skipped the urgent-care copay and the waiting room - texted a doctor and was done in minutes. Small thing, but it adds up. So glad {{city}} has this. 💙 #ADoctorIsJustATapAway',
    survey_share_urgent_care_caption_no_city:
      'Skipped the urgent-care copay and the waiting room - texted a doctor and was done in minutes. Small thing, but it adds up. 💙 #ADoctorIsJustATapAway',
    survey_share_doctor_quick_caption:
      "I've got a doctor I can reach - and now I can reach one by text in minutes, day or night. If you don't have a doctor you can get to, {{city}} gives you one. 💙 #ADoctorIsJustATapAway",
    survey_share_doctor_quick_caption_no_city:
      "I've got a doctor I can reach - and now I can reach one by text in minutes, day or night. 💙 #ADoctorIsJustATapAway",
    survey_share_waited_out_caption:
      "Normally I'd have just toughed it out - instead I texted a doctor and caught it early. Two minutes beats a weekend of feeling awful. {{city}} has this if you do too. 💙 #ADoctorIsJustATapAway",
    survey_share_waited_out_caption_no_city:
      "Normally I'd have just toughed it out - instead I texted a doctor and caught it early. Two minutes beats a weekend of feeling awful. 💙 #ADoctorIsJustATapAway",
    survey_share_label: 'Share',
    survey_share_facebook: 'Facebook',
    survey_share_x: 'Post on X',
    survey_share_copy_caption: 'Copy caption',
    survey_share_save_card: 'Save card image',

    // Survey Module - All Done Card
    survey_all_done_title: 'Thank You!',

    // Medical History Survey Module
    mhs_intro_title: 'Your Health Overview',
    mhs_intro_description:
      'Please answer a few quick questions so we can better understand your health and personalize your care.',
    mhs_medications_title: 'Current medications',
    mhs_medications_subtitle:
      'List all medications you currently take, including prescriptions, over-the-counter, vitamins, and supplements',
    mhs_conditions_title: 'Health conditions',
    mhs_conditions_subtitle: 'Select all health conditions that apply to you.',
    mhs_add_health_condition: 'Add health condition',
    mhs_surgical_title: 'Surgical history',
    mhs_surgical_subtitle: 'Tell us about any surgeries and procedures you have had in the past.',
    mhs_add_surgery: 'Add surgery',
    mhs_success_title: 'Thank You!',
    mhs_success_description: 'You can now return to the chat to continue with a provider.',

    // Medical History Survey - UI
    mhs_search_medication_placeholder: 'Search medication',
    mhs_search_condition_placeholder: 'Search condition',
    mhs_search_surgery_placeholder: 'Search surgical procedure',
    mhs_most_common_medications: 'Most common medications',
    mhs_most_common_conditions: 'Most common conditions',
    mhs_most_common_surgeries: 'Most common surgeries',
    mhs_no_medications: "I don't take any medication",
    mhs_other_medication_not_listed: 'Other medication that is not listed',
    mhs_no_conditions: "I don't have any health conditions",
    mhs_other_condition_not_listed: 'Other condition that is not listed',
    mhs_no_surgeries: "I haven't had any surgeries",
    mhs_other_surgery_not_listed: 'Other surgery that is not listed',
    mhs_validation_select_option: 'Please select at least one option',
    mhs_medication_type_label: 'Type:',
    mhs_medication_dose_label: 'Dose/Strength:',
    mhs_medication_frequency_label: 'How often:',
    mhs_frequency_once_daily: 'Once daily',
    mhs_frequency_twice_daily: 'Twice daily',
    mhs_frequency_three_times_daily: 'Three times daily',
    mhs_frequency_four_times_daily: 'Four times daily',
    mhs_frequency_as_needed: 'As needed',
    mhs_frequency_unknown: "I don't know",

    // Opt Out Module
    optout_title: 'Tap Telehealth Opt Out Request',
    optout_description:
      'Please fill out this form so we can forward your request to the City Utility Billing Department.',
    optout_account_number_label: 'Utility account number',
    optout_submit_button: 'Submit',
    optout_success_title: 'Thank You!',
    optout_success_subtitle:
      'Thank you for submitting your request. We will forward your information to the City Utility Billing Department.',
    optout_error_message: 'We are unable to submit your request at the moment. Please try again later.',
    optout_account_number_required: 'Please enter your utility account number',

    // Opt In Module
    optin_title: 'Rejoin {{programName}}',
    optin_description_opted_out_on: 'Your household opted out of {{programName}} on {{optedOutDate}}.',
    optin_description_opted_out: 'Your household has opted out of {{programName}}.',
    optin_description_address: 'The address on record is {{address}}.',
    optin_description_confirm: 'If you wish to opt back in, please check the box below and submit your request.',
    optin_members_intro: 'This will restore access to:',
    optin_confirm_label: 'I confirm I want to rejoin',
    optin_link_expired_title: 'This link has expired',
    optin_link_expired_subtitle: 'Text us again to get a new one.',
    optin_no_household_title: 'No household found',
    optin_no_household_subtitle: 'We could not find a household associated with your patient record.',
    optin_submit_button: 'Submit',
    optin_success_title: 'Thank You!',
    optin_success_subtitle: 'We have received your request.',
    optin_error_message: 'We are unable to submit your request at the moment. Please try again later.',
    optin_already_active_title: 'No Action Needed',
    optin_already_active_subtitle:
      'Your household is either already enrolled or has recently requested an update to its participation.',

    // Demographics form token
    demographics_load_error_title: "We couldn't load your form",
    demographics_link_expired_title: 'This link has expired',
    demographics_link_expired_subtitle: 'Message your provider to get a fresh one.',
    demographics_load_error_subtitle: 'Please try again in a moment.',
    demographics_wrong_patient: "This form belongs to another patient's record - please contact your provider",
    demographics_minor_adding_for: 'Adding a child for {{name}}',
    demographics_minor_existing_children: 'Children already on your record',

    // Medical History
    mh_medications_no_update: 'No, I need to update my medications',
    mh_conditions_no_update: 'No, I need to update my health conditions',
    mh_surgical_no_update: 'No, I need to update my surgical history',
    mh_medications_confirm_question: 'Is this medication information correct and complete?',
    mh_conditions_confirm_question: 'Is this condition information correct and complete?',
    mh_surgical_confirm_question: 'Is this surgical history information correct and complete?',
    mh_conditions_none_label: 'No known health conditions',
    mh_none_fallback_label: 'No items selected',
    mh_allergies_skip: "I don't have any allergies",
    mh_minor_allergies_skip: "The minor doesn't have any allergies",

    // Lab document
    lab_document_ready_title: 'Your lab document is ready',
    lab_document_open: 'Open document',
    lab_document_save: 'Save PDF',
    lab_document_expired_title: 'This link has expired',
    lab_document_expired_subtitle: 'Message your provider to get a fresh one.',
    lab_document_missing_title: 'Document not found',
    lab_document_missing_subtitle: 'Check the link in your message, or contact your provider.',
    lab_document_error_title: "We couldn't load your document",
    lab_document_error_subtitle: 'Please try again in a moment.',

    // Lab visit booking
    lab_visit_ordered_by: 'Lab tests ordered by Dr. {{name}}',
    lab_visit_ordered_by_care_team: 'Lab tests ordered by your care team',
    lab_visit_title_choose_location: 'Labs near you',
    lab_visit_title_your_visit: 'Your lab visit',
    lab_visit_title_walk_in: 'Just walk in - any day',
    lab_visit_fasting_title: 'This visit needs fasting',
    lab_visit_requisition_link: 'Need the paper lab slip? Download PDF',
    lab_visit_retry: 'Try again',
    lab_visit_not_found_title: 'Link not found',
    lab_visit_not_found_subtitle: 'Check the link in your message, or contact your care team.',
    lab_visit_expired_title: 'This link has expired',
    lab_visit_expired_subtitle: 'Message your care team to get a fresh one.',
    lab_visit_expired_sms: 'Message your care team',
    lab_visit_rate_limited_title: 'One moment...',
    lab_visit_rate_limited_subtitle: 'Please wait a few seconds and try again.',
    lab_visit_searching_near: 'Searching near',
    lab_visit_find_locations: 'Find locations',
    lab_visit_zip_hint: 'Going somewhere else this week? Change the ZIP - near work is fine too.',
    lab_visit_location_distance: '{{miles}} mi',
    lab_visit_location_site_code: 'Site {{code}}',
    lab_visit_book_a_time: 'Book a time',
    lab_visit_just_walk_in: 'Just walk in',
    lab_visit_show_more: 'Show more ({{count}} more nearby)',
    lab_visit_locations_empty: 'No Quest locations came back for that ZIP. Try a nearby one.',
    lab_visit_locations_error: "We couldn't load locations. Please try again.",
    lab_visit_slots_title: 'When works for you?',
    lab_visit_all_locations: 'All locations',
    lab_visit_slot_first: 'First',
    lab_visit_slots_empty: 'No open times came back for this location. Try another one.',
    lab_visit_slots_error: "We couldn't load times for this location. Please try again.",
    lab_visit_slot_taken: 'That time was just taken - here are the current options.',
    lab_visit_book_error: "We couldn't book that time. Please try again.",
    lab_visit_booked_eyebrow: "You're all set",
    lab_visit_booked_when: '{{date}} at {{time}}',
    lab_visit_confirmation_code: 'Confirmation code {{code}}',
    lab_visit_confirmation_hint: 'The front desk can look you up by it.',
    lab_visit_bring_photo_id: "A photo ID - driver's license is fine",
    lab_visit_bring_empty_stomach: 'An empty stomach',
    lab_visit_bring_nothing_else: "That's it - no paperwork, your order is already waiting in their system",
    lab_visit_show_check_in_card: 'Show my check-in card',
    lab_visit_change_time: 'Change time',
    lab_visit_keep_current_time: 'Keep current time',
    lab_visit_cancel_visit: 'Cancel visit',
    lab_visit_cancel_confirm_title: 'Cancel this visit?',
    lab_visit_cancel_confirm_description:
      'Are you sure you want to cancel your booked time slot? Once confirmed you can book a new time',
    lab_visit_cancel_confirm_keep: 'Keep it',
    lab_visit_cancel_error: "We couldn't cancel your visit. Please try again.",
    lab_visit_walk_in_intro:
      "Your order is already in Quest's system. Come in whenever the location is open - no appointment needed.",
    lab_visit_walk_in_pick_label: 'Your pick',
    lab_visit_walk_in_any_location: 'Any Quest location',
    lab_visit_walk_in_bring_label: 'Bring these',
    lab_visit_bring_photo_id_label: 'A photo ID',
    lab_visit_bring_photo_id_detail: "That's genuinely all Quest needs",
    lab_visit_bring_stomach_water: 'Water is fine; skip breakfast that morning',
    lab_visit_bring_stomach_nothing: 'Nothing to eat or drink before your visit',
    lab_visit_book_a_time_instead: 'Book a time instead',
    lab_visit_walk_in_error: "We couldn't save your walk-in. Please try again.",
    lab_visit_walk_in_switch_error: "We couldn't switch to booking. Please try again.",
    lab_visit_check_in_title: 'Show this at the desk',
    lab_visit_check_in_patient: 'Patient',
    lab_visit_check_in_dob: 'Date of birth',
    lab_visit_check_in_requisition: 'Requisition',
    lab_visit_check_in_confirmation: 'Confirmation code',
    lab_visit_check_in_you_owe: 'You owe',
    lab_visit_check_in_error: "We couldn't load your check-in card. Please try again.",
    lab_visit_degraded_eyebrow: 'Online booking is down right now',
    lab_visit_degraded_intro: "Quest's scheduling system isn't responding. It's usually back within the hour.",
    lab_visit_degraded_good_news:
      "<strong>Good news:</strong> you don't actually need an appointment. Your order is already in their system - you can walk in any time they're open.",
    lab_visit_degraded_find_quest: 'Find a Quest location',
    lab_visit_degraded_bring_slip: 'Bring your lab slip with you.',
    lab_visit_walk_in_instead: 'Walk in instead',
    lab_visit_try_booking_again: 'Try booking again',
    lab_visit_upstream_down_notice:
      "Quest's scheduling system isn't responding, so this visit can't be changed or cancelled right now. Try again in a few minutes.",
    lab_visit_error_title: "We couldn't load your lab visit",
    lab_visit_error_subtitle: 'Please try again in a moment.',

    // Visits & notes
    menu_visits_notes: 'Visits & notes',
    visits_notes_title: 'Visits & notes',
    visits_notes_load_more: 'Load more',
    visits_notes_practitioner: 'Dr. {{name}}',
    visits_notes_medications_prescribed_one: '{{count}} Medication prescribed',
    visits_notes_medications_prescribed_other: '{{count}} Medications prescribed',
    visits_notes_lab_order: 'Blood work',
    visits_notes_filter_all: 'All',
    visits_notes_filter_visits: 'Visits',
    visits_notes_filter_notes: 'School & work notes',
    visits_notes_filter_tests: 'Tests',
    visits_notes_empty_notes: 'No school & work notes to show from the loaded visits',
    visits_notes_empty_tests: 'No tests to show from the loaded visits',
    visits_notes_error_title: "We couldn't load your visits",
    visits_notes_error_subtitle: 'Please try again in a moment.',

    // Lab results
    menu_savings: 'Savings',
    savings_title: 'Your savings',
    savings_subtitle: 'A little more room for the things that matter.',
    savings_scope_me: 'Me',
    savings_scope_household: 'Household',
    savings_period_option_all_time: 'All time',
    savings_period_option_this_month: 'This month',
    savings_period_option_last_month: 'Last month',
    savings_period_option_this_year: 'This year',
    savings_period_option_last_year: 'Last year',
    savings_period_option_custom: 'Custom range',
    savings_period_all_time: 'all time',
    savings_period_this_month: 'this month',
    savings_period_last_month: 'last month',
    savings_period_this_year: 'this year',
    savings_period_last_year: 'last year',
    savings_period_custom: '{{from}} – {{to}}',
    savings_total_eyebrow: 'Your everyday value',
    savings_total_period: 'Estimated savings {{period}}',
    savings_total_period_empty: 'Savings recorded {{period}}',
    savings_empty_title: 'No savings recorded yet',
    savings_empty_subtitle:
      'After you use Tap, any savings from your care, prescriptions, lab tests, and weight management will appear here automatically.',
    savings_category_prescriptions: 'Prescription savings',
    savings_category_care: 'Care savings',
    savings_category_labs: 'Lab test savings',
    savings_category_weight_program: 'Weight management savings',
    savings_category_workdays: 'Workdays recovered',
    savings_count_prescriptions: '{{count}} medication(s)',
    savings_count_care: '{{count}} visit(s)',
    savings_count_labs: '{{count}} lab test(s)',
    savings_count_weight_program: '{{count}} month(s) of program fees',
    savings_count_workdays_one: '{{days}} day',
    savings_count_workdays_other: '{{days}} days',
    savings_error_savings_disabled_title: 'Savings isn’t available right now',
    savings_error_savings_disabled_subtitle: 'Please check back later.',
    savings_error_not_found_title: 'We couldn’t find savings for this patient',
    savings_error_not_found_subtitle: 'Try selecting a different patient.',
    savings_error_invalid_period_title: 'That date range isn’t valid',
    savings_error_invalid_period_subtitle: 'Choose a start date on or before the end date.',
    savings_error_unknown_title: 'We couldn’t load your savings',
    savings_error_unknown_subtitle: 'Please try again later.',
    savings_drawer_close: 'Close',
    savings_drawer_total_prescriptions: 'Total saved on {{count}} medication(s)',
    savings_drawer_total_care: 'Total saved on {{count}} visit(s)',
    savings_drawer_total_labs: 'Total saved on {{count}} lab test(s)',
    savings_drawer_total_weight_program: 'Total saved on {{count}} month(s) of weight program',
    savings_drawer_total_workdays_one: 'Total saved on {{days}} recovered workday',
    savings_drawer_total_workdays_other: 'Total saved on {{days}} recovered workdays',
    savings_drawer_retail_price: 'Retail price',
    savings_drawer_you_paid: 'You paid',
    savings_drawer_estimated_expenses: 'Estimated personal expenses',
    savings_breakdown_title: 'Savings breakdown',
    savings_breakdown_empty: 'No savings recorded for this period.',
    savings_column_date: 'Date',
    savings_column_patient: 'Patient',
    savings_column_medication: 'Medication',
    savings_column_retail_estimate: 'Retail estimate',
    savings_column_coupon_price: 'Coupon price',
    savings_column_insurance_price: 'Insurance price estimate',
    savings_column_price_used: 'Price used',
    savings_column_savings: 'Savings',
    savings_column_care_option: 'Other care option',
    savings_column_estimated_expenses: 'Estimated personal expenses',
    savings_column_lab_test: 'Lab test',
    savings_column_program: 'Program',
    savings_column_workdays: 'Workdays recovered',
    savings_column_workday_value: 'Estimated value per workday',
    savings_care_option_no_medical_care: '911, ambulance and emergency room',
    savings_care_option_no_care_options: 'Emergency room visit',
    savings_care_option_urgent_care: 'Urgent care visit',
    savings_care_option_doctor_quick: 'Primary care visit',
    savings_care_option_waited_out: 'Waited it out',
    savings_workdays_value_one: '{{days}} workday',
    savings_workdays_value_other: '{{days}} workdays',
    savings_explainer_title: 'How your savings are estimated',
    savings_explainer_intro:
      'Care, prescriptions, and time away from work can add up. Here’s how we estimate the value you get from Tap, using your care records, survey answers, and price comparisons.',
    savings_explainer_prescriptions_title: 'Prescription savings',
    savings_explainer_prescriptions_p1:
      'We compare the estimated retail price of your medication with the lowest available comparable coupon or insurance price. The biggest potential saving is added to your total.',
    savings_explainer_prescriptions_p2:
      'Your final pharmacy price may be different. Knowing you received your medication doesn’t tell us how much you paid, so this remains an estimate.',
    savings_explainer_prescriptions_p3:
      'Based on retail and coupon prices from DoseSpot coupon reports, and insurance estimates from DoseSpot’s real-time prescription benefit information.',
    savings_explainer_care_title: 'Care savings',
    savings_explainer_care_p1:
      'In your survey, you tell us where you would have gone if Tap hadn’t been available. We use a typical cost estimate for that care option to calculate what you might have spent.',
    savings_explainer_care_p2:
      'If you chose “wait it out,” that visit adds nothing to your savings. If you didn’t answer, we leave that visit out of this calculation.',
    savings_explainer_care_p3: 'Based on your survey answer and Tap’s set estimates for each care option.',
    savings_explainer_labs_title: 'Lab test savings',
    savings_explainer_labs_p1:
      'For each free lab order, we add a set estimated saving once all your results are available.',
    savings_explainer_labs_p2: 'Each order counts once, whether it includes one test or several tests and panels.',
    savings_explainer_labs_p3: 'Based on completed lab orders in your records and Tap’s set estimate per order.',
    savings_explainer_weight_program_title: 'Weight management savings',
    savings_explainer_weight_program_p1:
      'We add a set estimated saving for each calendar month you participate in the weight management program after treatment begins.',
    savings_explainer_weight_program_p2:
      'A partial month counts as a full month. Each month is counted only once, even if participation periods overlap. Any medication savings are included under prescription savings.',
    savings_explainer_weight_program_p3: 'Based on your treatment dates and a comparison monthly program fee.',
    savings_explainer_workdays_title: 'Workdays recovered',
    savings_explainer_workdays_p1:
      'Your survey tells us how much work time you recovered. We count your answer as half a day, 1, 2, or 3 days, then multiply it by a set value per workday.',
    savings_explainer_workdays_p2:
      'If you recovered time caring for your child, those days are credited to you as the parent. For a shared visit, we use the highest number of days reported and count it once.',
    savings_explainer_workdays_p3:
      'This is an estimate of the value of your time, not confirmed income or money received.',
    savings_explainer_workdays_p4:
      'Based on your survey answers. The daily value comes from U.S. Bureau of Labor Statistics median weekly earnings, divided by five working days.',
    menu_lab_results: 'Test results',
    lab_results_title: 'Test results',
    lab_results_subtitle:
      'Every order you placed or your doctor placed for you, newest first. Open one to see its tests.',
    lab_results_order_number: 'Order #{{number}}',
    lab_results_kind_panel: 'Panel',
    lab_results_kind_individual_tests: 'Individual tests',
    lab_results_kind_mixed: 'Panel + tests',
    lab_results_ordered_by: 'Ordered by Dr. {{name}}',
    lab_results_ordered_by_you: 'Ordered by you',
    lab_results_ordered_by_care_team: 'Ordered by your care team',
    lab_results_released_on: 'Released {{date}}',
    lab_results_status_awaiting_visit: 'Awaiting visit',
    lab_results_status_scheduled: 'Visit booked',
    lab_results_status_processing: 'Waiting for results',
    lab_results_status_results_ready: 'Results ready',
    lab_results_status_rejected: 'Could not be processed',
    lab_results_status_cancelled: 'Cancelled',
    lab_results_status_expired: 'Expired',
    lab_results_status_failed: 'Could not be completed',
    lab_results_badge_needs_attention: '{{count}} needs attention',
    lab_results_badge_worth_a_look: '{{count}} worth a look',
    lab_results_badge_in_range: 'In range',
    lab_results_empty: 'No test results yet. When your doctor orders lab tests, they will show up here.',
    lab_results_error_title: "We couldn't load your test results",
    lab_results_error_subtitle: 'Please try again in a moment.',

    // Lab results - order details
    lab_results_order_not_found_title: 'We could not find this order',
    lab_results_order_not_found_subtitle: 'It may belong to another patient, or the results are not released yet.',
    lab_results_biomarker_count_one: '{{count}} biomarker',
    lab_results_biomarker_count_other: '{{count}} biomarkers',
    lab_results_test_count_one: '{{count}} test',
    lab_results_test_count_other: '{{count}} tests',
    lab_results_group_in_range: 'In range',
    lab_results_group_worth_a_look: 'Worth a look',
    lab_results_group_other: 'Other',
    lab_results_group_needs_attention: 'Needs attention',
    lab_results_test_status_pending: 'Waiting',
    lab_results_test_status_final: 'Results received',
    lab_results_test_status_corrected: 'Corrected',
    lab_results_test_status_not_performed: 'Not performed',
    lab_results_update_pending:
      'The lab corrected one of these results and your doctor is reviewing the change. What you see here may be updated.',
    lab_results_report_download: 'Download (PDF)',
    lab_results_report_filename: 'lab-report-{{number}}.pdf',
    lab_results_report_error: "We couldn't download your report. Please try again.",
    lab_results_note_title: 'Clinical note',
    lab_results_note_author: 'Dr. {{name}}',
    lab_results_note_empty: 'No note. Your doctor reviewed these results and released them without comments.',
    lab_results_chip_all: 'All ({{count}})',
    lab_results_filter_empty: 'No results match the selected filter.',
    lab_results_attention_eyebrow: 'Needs attention now',
    lab_results_attention_title_single: 'One result needs immediate care',
    lab_results_attention_title_multiple: '{{count}} results need immediate care',
    lab_results_attention_reference: '(lab reference {{reference}})',
    lab_results_attention_eyebrow_soon: 'Contact a doctor soon',
    lab_results_attention_title_single_soon: 'One result needs attention soon',
    lab_results_attention_title_multiple_soon: '{{count}} results need attention soon',
    lab_results_attention_no_guide: 'The lab flagged this result critical. Your doctor will contact you.',
    lab_safety_net_emergency: 'Call 911 or go to the ER if',
    lab_safety_net_same_day: 'See a doctor today if',
    lab_results_text_doctor: 'Text a Tap doctor',
    lab_results_attention_hours: 'Tap messaging 7 am-10 pm. Messaging does not replace immediate care.',
    lab_results_ask_doctor_note: 'Questions about this order? Your doctor sees this result next to your message.',
    lab_results_ask_doctor_cta: 'Ask a Tap doctor',
    lab_results_state_waiting_title: 'Waiting for results',
    lab_results_state_waiting_body:
      'Your sample has not reached the lab yet. Most results arrive within 2-3 days after your visit; we will text you when they are ready.',
    lab_results_state_processing_title: 'Waiting for results',
    lab_results_state_processing_body:
      'Your sample is with the lab. Most results arrive within 2-3 days of your visit; we will text you when they are ready.',
    lab_results_state_partial_title: 'Some results are on their way',
    lab_results_state_partial_body:
      'Some of your results have been received and the rest are still with the lab. We will text you when they are all ready.',
    lab_results_state_rejected_title: 'This order could not be processed',
    lab_results_state_rejected_body: 'The lab could not accept this order. Your doctor will follow up with you.',
    lab_results_state_cancelled_title: 'This order was cancelled',
    lab_results_state_cancelled_body: 'No results will come from this order.',
    lab_results_state_expired_title: 'This order expired',
    lab_results_state_expired_body: 'No sample was collected in time. Your doctor can order the tests again.',
    lab_results_state_failed_title: 'This order could not be completed',
    lab_results_state_failed_body: 'No results will come from this order. Your doctor will follow up with you.',

    // Lab results - biomarker details
    lab_marker_not_found_title: 'We could not find this result',
    lab_marker_not_found_subtitle: 'It may belong to another patient, or it has not been released yet.',
    lab_marker_result: 'Your result',
    lab_marker_result_on: 'Your result · {{date}}',
    lab_marker_reference_caption:
      'Lab reference {{reference}}. The range comes from this report. It is not the same as an urgent or critical threshold.',
    lab_marker_reference_plain: 'Lab reference {{reference}}',
    lab_marker_meaning_title: 'What your result means',
    lab_marker_next_step_title: 'What should I do next?',
    lab_marker_why_this_matters: 'Why this matters',
    lab_marker_ask_doctor_note: 'Questions about this result? Your doctor sees this result next to your message.',
    lab_marker_content_pending: 'The explanation for this result is being reviewed by Tap doctors.',
    lab_marker_action_eyebrow: 'Take action now',
    lab_marker_variants_title: 'Does any of this apply to you?',
    lab_marker_variants_subtitle:
      'Pick one and the explanation below is rewritten for that situation. Your result does not change.',
    lab_marker_variants_adjusted: 'Explanation adjusted for: {{label}}',
    lab_marker_variant_female_pregnant: "I'm pregnant",
    lab_marker_variant_postmenopausal: 'After menopause',

    // Lab results - order history
    lab_results_history_title: 'Order history',
    lab_results_history_progress: '{{done}} of {{total}} steps',
    lab_results_history_ordered: 'Ordered',
    lab_results_history_ordered_by: 'Ordered by Dr. {{name}}',
    lab_results_history_ordered_by_you: 'Ordered by you',
    lab_results_history_ordered_by_care_team: 'Ordered by your care team',
    lab_results_history_ordered_detail_add_ons_one: '{{panels}} + {{count}} add-on test',
    lab_results_history_ordered_detail_add_ons_other: '{{panels}} + {{count}} add-on tests',
    lab_results_history_sent_to_lab: 'Sent to Quest Diagnostics',
    lab_results_history_sent_detail: 'Lab slip ready, no fasting needed',
    lab_results_history_sent_detail_fasting: 'Lab slip ready, fasting required',
    lab_results_history_visit_scheduled: 'Visit booked',
    lab_results_history_visit_scheduled_next: 'Book a visit',
    lab_results_history_visit_detail_next: 'Pick a Quest location and time, or walk in any morning',
    lab_results_history_sample_collected: 'Sample collected',
    lab_results_history_collected_walk_in: 'Walked in at {{location}}',
    lab_results_history_collected_at: 'Collected at {{location}}',
    lab_results_history_results_partial: 'Some results in',
    lab_results_history_results_partial_detail: '{{resulted}} of {{total}} tests resulted',
    lab_results_history_results_final: 'All results in',
    lab_results_history_results_final_next: 'Results',
    lab_results_history_results_final_detail: '{{tests}}, {{biomarkers}}',
    lab_results_history_results_final_detail_next: 'Usually 2-3 days after your visit. We text you when they are ready',
    lab_results_history_provider_review: 'Reviewed by your doctor',
    lab_results_history_reviewed_by: 'Reviewed by Dr. {{name}}',
    lab_results_history_provider_review_next: 'Doctor review',
    lab_results_history_provider_review_detail: 'No action needed',
    lab_results_history_results_released: 'Released to you',
    lab_results_history_results_released_next: 'Results released',
    lab_results_history_results_released_detail: 'Text message sent',

    // Free labs signup
    free_labs_eyebrow: 'Free lab tests · Paid for by Tap · $0 to you',
    free_labs_community: 'Community: {{name}}',
    free_labs_community_batavia: 'Batavia, IL',
    free_labs_community_aurora: 'Aurora, IL',
    free_labs_community_rolling_meadows: 'Rolling Meadows, IL',
    free_labs_title_phone: 'Free lab tests for residents',
    free_labs_title_code: 'Enter the code we texted you',
    free_labs_title_picker: 'Who is ordering today?',
    free_labs_title_form_new: 'Tell us about yourself',
    free_labs_title_form_returning: 'Welcome back, {{name}}',
    free_labs_session_expired: 'Your session expired. Verify your mobile number again to continue.',
    free_labs_unavailable_title: 'Free lab tests are not available right now',
    free_labs_unavailable_subtitle: 'Please try again later.',
    free_labs_error_generic: 'Something went wrong. Please try again.',
    free_labs_error_rate_limited: 'Too many attempts. Please wait a few minutes and try again.',
    free_labs_error_send_failed: "We couldn't send the code. Please try again.",
    free_labs_phone_intro:
      'You are about to order a free blood test panel. The laboratory requires a verified mobile number before we can place an order. We will text you a 6-digit code.',
    free_labs_phone_note: 'One panel per person. Your insurance does not affect eligibility.',
    free_labs_phone_label: 'Mobile number',
    free_labs_phone_required: 'Enter your mobile number',
    free_labs_phone_invalid: 'Enter a valid US mobile number',
    free_labs_phone_cta: 'Text me a code',
    free_labs_phone_footer: 'Message rates may apply. This number is where your booking link and results will be sent.',
    free_labs_code_sent_to: 'Sent to <strong>{{phone}}</strong>.',
    free_labs_code_change_number: 'Change number',
    free_labs_code_cta: 'Verify',
    free_labs_code_resend_prompt: "Didn't get it?",
    free_labs_code_resend: 'Resend code',
    free_labs_code_resent: 'We sent you a new code.',
    free_labs_code_invalid: "That code isn't right. Check the text and try again.",
    free_labs_code_expired: 'That code expired. Request a new one.',
    free_labs_picker_intro:
      'More than one adult in your household uses this number. Pick yourself so we can prefill your details.',
    free_labs_picker_born: 'Born {{year}}',
    free_labs_picker_unnamed: 'Household member',
    free_labs_picker_order_placed: 'Order placed',
    free_labs_picker_footnote:
      'Not in the list? A known phone can only sign up the adults already registered on it. Use your own mobile number instead.',
    free_labs_picker_cta: 'Continue',
    free_labs_picker_not_on_phone: "We couldn't load that person's details. Pick again or use your own mobile number.",
    free_labs_last_request_title: "Your request from {{date}} didn't go through",
    free_labs_last_request_outside_city:
      "The address was outside the program's city limits. If you've moved or the address was wrong, update it below and submit again.",
    free_labs_last_request_quota_full:
      'All free panels in that community were taken at the time. You can submit again below.',
    free_labs_last_request_duplicate:
      'A free panel was already ordered for this person. Check your text messages for your booking link or results.',
    free_labs_last_request_address_unresolved:
      "We couldn't place the address on a map. Pick it from the suggestions below and submit again.",
    free_labs_last_request_order_failed:
      "The laboratory didn't accept the order. Our team was notified; you can submit again below.",
    free_labs_last_order_title: 'Your order from {{date}} is no longer active',
    free_labs_last_order_expired:
      'The lab slip expired before a sample was collected. Check your details and submit again below.',
    free_labs_last_order_cancelled: 'The order was cancelled. Check your details and submit again below.',
    free_labs_last_order_rejected: "The laboratory didn't accept the order. Check your details and submit again below.",
    free_labs_last_order_failed: "The laboratory didn't accept the order. Check your details and submit again below.",
    free_labs_need_email_title: 'We need your email',
    free_labs_need_email_body:
      "The laboratory sends collection instructions by email. We don't have a valid one on file yet.",
    free_labs_dob_hint: 'You must be 18 or older.',
    free_labs_sex: 'Sex',
    free_labs_sex_hint: 'Required by the laboratory for reference ranges.',
    free_labs_email_required: 'Email is required',
    free_labs_email_taken: 'This email belongs to another patient. Use a different one.',
    free_labs_phone_taken: 'This phone number belongs to another patient. Please contact us.',
    free_labs_phone_verified: 'Verified',
    free_labs_address: 'Home address',
    free_labs_address_required: 'Pick your address from the suggestions',
    free_labs_address_change: 'Change',
    free_labs_consents_legend: 'Please confirm',
    free_labs_consent_required: 'Please tick this box to continue',
    free_labs_consent_attestation: 'I am 18 or older and I live at the address above.',
    free_labs_consent_sms:
      'Tap may text me about my lab order and results. Message rates may apply. Reply STOP at any time.',
    free_labs_consent_hipaa:
      'I agree to the <telehealth>telehealth consent</telehealth>, <terms>terms of use</terms> and <privacy>privacy policy</privacy>.',
    free_labs_form_not_on_phone: 'This person is not registered on your mobile number.',
    free_labs_submit_cta: 'Place my free order',
    free_labs_ordered_title: 'Your free lab order is placed',
    free_labs_ordered_subtitle:
      "Results come by text, or a Tap provider will contact you to go over them. We'll also text <strong>{{phone}}</strong> the booking link.",
    free_labs_ordered_waiting_title: 'Waiting for the lab to confirm your order…',
    free_labs_ordered_waiting_body:
      'This usually takes a moment. You can also close this page: the booking link will arrive by text.',
    free_labs_ordered_texted_title: "We'll text you the booking link",
    free_labs_ordered_texted_body:
      'The lab is still confirming your order. As soon as it does, the link to book your visit arrives by text.',
    free_labs_book_visit: 'Book your lab visit',
    free_labs_book_visit_caption: 'Same link we texted you. Results arrive by text or a Tap provider will contact you.',
    free_labs_already_title: "Hi {{name}}, you're all set",
    free_labs_already_title_unnamed: "You're all set",
    free_labs_already_subtitle:
      "We placed your free lab order on {{date}}. One panel per person, so there's nothing more to submit.",
    free_labs_already_book: 'Same link we texted you. Results arrive by text or a Tap provider will contact you.',
    free_labs_already_awaiting_requisition:
      "The lab hasn't issued your requisition yet. We'll text you the booking link shortly.",
    free_labs_already_results_pending: "Your sample was collected. We'll text you when your results are ready.",
    free_labs_already_released: 'Your results were sent by text. Check your messages for the results link.',
    free_labs_declined_outside_city_title: 'This address is outside the program area',
    free_labs_declined_outside_city_body:
      "Free panels are for residents inside Batavia, Aurora or Rolling Meadows city limits. The address you entered falls outside them. If it's wrong, go back and pick your address again.",
    free_labs_declined_quota_full_title: 'All free panels in your area are taken',
    free_labs_declined_quota_full_title_named: 'All free panels for {{name}} are taken',
    free_labs_declined_quota_full_body:
      "The program covers a limited number of residents and that limit has been reached. We've kept your details.",
    free_labs_declined_duplicate_title: 'A free panel was already ordered for you',
    free_labs_declined_duplicate_body:
      "One panel per person, so there's nothing more to submit. Check your text messages for your booking link or results.",
    free_labs_declined_address_unresolved_title: "We couldn't place your address on the map",
    free_labs_declined_address_unresolved_body:
      "Pick your address from the suggestions so we can check it's inside the program area.",
    free_labs_declined_order_failed_title: "We couldn't place your order",
    free_labs_declined_order_failed_body:
      'Something went wrong on the laboratory side. Our team has been notified and will text you at {{phone}} to finish your order. No action needed.',
    free_labs_fix_address: 'Fix my address',

    // Weight program (Foundayo)
    menu_weight_program: 'Weight program',
    weight_program_brand: 'Weight program',

    weight_program_intro_title: 'Foundayo for weight management',
    weight_program_intro_body:
      'Foundayo (orforglipron) is a daily tablet used with a food and activity plan. Answer 10 short questions so a Tap doctor can review whether it may be right for you.',
    weight_program_intro_how_label: 'How it works',
    weight_program_intro_how_value: '10 questions → doctor review → decision',
    weight_program_intro_takes_label: 'Takes',
    weight_program_intro_takes_value: 'About 5 minutes',
    weight_program_intro_cost_label: 'Cost of review',
    weight_program_intro_cost_value: 'Included in your Tap care',
    weight_program_intro_disclaimer:
      'Completing the form does not guarantee a prescription. You can choose "Not sure" when you need help. Medicine cost and pharmacy availability are discussed with your doctor.',
    weight_program_intro_start: 'Start',
    weight_program_intro_start_failed: 'We could not start the program. Please try again.',
    weight_program_how_title: 'How the program works',
    weight_program_how_step_review:
      'A doctor reviews your starting form, confirms your measurements and eating history, agrees on a health goal with you, and approves the plan.',
    weight_program_how_step_first_dose:
      'You confirm the day you take your first tablet, and later the day you start any new dose. Your doctor may check in with you 1–2 weeks after starting or changing a dose, sooner if you have a concern.',
    weight_program_how_step_monthly:
      'About once a month you get a short check-in form, with reminders if it is not done.',
    weight_program_how_step_changes:
      'The doctor reviews every check-in before any change to your prescription. If a question is skipped, the care team follows up.',
    weight_program_how_step_goal:
      'Reaching your goal starts a conversation about maintenance. If the medicine is stopped, the doctor agrees on follow-up and a way back into care.',

    weight_program_consent_title: 'Before you start',
    weight_program_consent_body_review:
      'Your answers are stored in your Tap chart and reviewed by a Tap doctor. Tap uses AI tools to organize your answers for the doctor; the AI does not make treatment decisions. Your doctor decides about eligibility, prescriptions and any changes.',
    weight_program_consent_body_sms:
      'Monthly check-ins are part of this program. We will text you a link to a short form about once a month, with reminders if it is not completed.',
    weight_program_consent_ai_and_doctor_review:
      'I understand that a doctor reviews my answers and makes every treatment decision, and that AI is used only to organize information.',
    weight_program_consent_program_sms:
      'I agree to receive text messages about this program, including monthly check-in links and reminders.',
    weight_program_consent_continue: 'Continue',
    weight_program_consent_accepted_on: 'You agreed on {{date}}.',
    weight_program_consent_failed: 'We could not save your consents. Please try again.',

    weight_program_submitted_title: 'Thank you. Your answers are with your doctor.',
    weight_program_submitted_body:
      'A Tap doctor will review them and let you know the next step. This form does not approve a prescription.',
    weight_program_submitted_status_label: 'Status',
    weight_program_submitted_status_value: 'Awaiting doctor review',
    weight_program_submitted_sent_label: 'Sent',
    weight_program_submitted_answers_title: 'Your answers',

    weight_program_eyebrow: 'Getting started',
    weight_program_progress_label: 'Your progress',
    weight_program_question_counter: 'Question {{current}} of {{total}}',
    weight_program_review_title: 'Review your answers',
    weight_program_review_helper:
      'You can go back and change anything before sending. After sending, your doctor reviews these answers; changes go through Chat.',
    weight_program_review_back: 'Back to questions',
    weight_program_submit: 'Submit',
    weight_program_not_answered: 'Not answered',
    weight_program_height_label: 'Your height',
    weight_program_weight_label: 'Your weight',
    weight_program_measured_on_label: 'When did you measure?',
    weight_program_problem_missing: 'Please answer this question before continuing.',
    weight_program_problem_choose_one: 'Please choose one option.',
    weight_program_problem_exclusive_option: 'That option cannot be combined with the others.',
    weight_program_problem_measurements_incomplete: 'Please fill in your height, weight and the date.',
    weight_program_problem_measured_on_in_future: 'The date cannot be in the future.',
    weight_program_problem_detail_required: 'Please list your medicines and supplements.',
    weight_program_flag_title_emergency: 'Get help now',
    weight_program_flag_title_poison_control: 'Call Poison Control now: 1-800-222-1222.',
    weight_program_flag_title_same_day: 'Your care team will contact you today.',
    weight_program_problem_inconsistent: 'Days in a row can’t be more than the total days missed.',
    weight_program_save_failed: 'We could not save your answer. Please check your connection and try again.',
    weight_program_submit_failed: 'We could not send your answers. Please try again.',
    weight_program_load_failed: 'We could not load your form. Please try again.',
    weight_program_option_yes: 'Yes',
    weight_program_option_no: 'No',
    weight_program_option_not_sure: "I'm not sure",
    weight_program_option_none: 'None of these',
    weight_program_helper_choose_all: 'Choose all that apply.',
    weight_program_body_measurements_title: 'What are your height and weight?',
    weight_program_body_measurements_helper: 'Use a recent measured value.',
    weight_program_weight_related_conditions_title: 'Has a doctor told you that you have any of these?',
    weight_program_weight_related_conditions_option_hypertension: 'High blood pressure',
    weight_program_weight_related_conditions_option_high_cholesterol: 'High cholesterol',
    weight_program_weight_related_conditions_option_type_2_diabetes: 'Type 2 diabetes',
    weight_program_weight_related_conditions_option_sleep_apnea: 'Sleep apnea',
    weight_program_weight_related_conditions_option_heart_disease: 'Heart disease',
    weight_program_reproductive_status_title: 'Do any of these apply to you?',
    weight_program_reproductive_status_option_pregnant_or_possible: 'I am pregnant or might be pregnant',
    weight_program_reproductive_status_option_planning_pregnancy: 'I plan to become pregnant',
    weight_program_reproductive_status_option_breastfeeding: 'I am breastfeeding',
    weight_program_reproductive_status_option_oral_contraceptives: 'I take birth-control pills',
    weight_program_reproductive_status_option_prefer_to_discuss: 'I prefer to discuss this',
    weight_program_mtc_men2_history_title: 'Have you or your family had MTC or MEN2?',
    weight_program_mtc_men2_history_helper:
      "MTC means medullary thyroid cancer, a rare thyroid cancer. MEN2 is a condition that causes tumors. Choose 'I'm not sure' if you need help.",
    weight_program_glp1_allergy_title:
      'Have you had a serious allergy to Foundayo or another weight or diabetes medicine?',
    weight_program_glp1_allergy_detail_label: 'Medicine name (optional)',
    weight_program_gi_organ_history_title: 'Have you had any of these health problems?',
    weight_program_gi_organ_history_option_pancreatitis: 'Pancreatitis (a swollen pancreas)',
    weight_program_gi_organ_history_option_gallstones: 'Gallstones',
    weight_program_gi_organ_history_option_gastroparesis: 'Very slow stomach emptying',
    weight_program_gi_organ_history_option_recurrent_vomiting: 'Repeated vomiting',
    weight_program_gi_organ_history_option_kidney_disease: 'Kidney disease',
    weight_program_gi_organ_history_option_severe_liver_disease: 'Serious liver disease',
    weight_program_gi_organ_history_option_diabetic_retinopathy: 'Eye damage from diabetes',
    weight_program_eating_disorder_screen_title: 'Have you had an eating disorder or any of these concerns?',
    weight_program_eating_disorder_screen_helper:
      'Choose all that apply, including past concerns. Your answers help us plan support.',
    weight_program_eating_disorder_screen_option_anorexia_history:
      'Anorexia (severe food restriction and fear of weight gain)',
    weight_program_eating_disorder_screen_option_bulimia_history:
      'Bulimia (binge eating followed by trying to undo it)',
    weight_program_eating_disorder_screen_option_binge_or_other_history:
      'Binge-eating disorder or another eating disorder',
    weight_program_eating_disorder_screen_option_restricting_from_fear: 'I skip food because I fear gaining weight',
    weight_program_eating_disorder_screen_option_purging_or_compensating:
      'I vomit, use laxatives or water pills, or exercise to undo eating',
    weight_program_eating_disorder_screen_option_loss_of_control_eating: 'I sometimes feel unable to stop eating',
    weight_program_eating_disorder_screen_option_prefer_to_discuss: 'I would rather talk with my clinician',
    weight_program_eating_disorder_screen_detail_label: 'Anything you want your clinician to know? (optional)',
    weight_program_current_medications_title: 'Do you take any medicines or supplements?',
    weight_program_current_medications_helper:
      'Include insulin, diabetes or weight medicines, online products, supplements, and birth control.',
    weight_program_current_medications_option_will_list: 'Yes',
    weight_program_current_medications_option_takes_none: 'No',
    weight_program_current_medications_option_need_help: 'I need help with my list',
    weight_program_current_medications_detail_label: 'Your medicines and supplements',
    weight_program_planned_anesthesia_title: 'Do you have surgery or anesthesia planned?',
    weight_program_planned_anesthesia_helper: 'Anesthesia is medicine that makes you sleep for a procedure.',
    weight_program_planned_anesthesia_date_label: 'Date, if you know it (optional)',
    weight_program_support_needs_title: 'What would you like help with before starting?',
    weight_program_support_needs_option_medicine_questions: 'Understanding the medicine',
    weight_program_support_needs_option_side_effects: 'Side effects',
    weight_program_support_needs_option_cost_or_access: 'Cost or getting the medicine',
    weight_program_support_needs_option_food_or_activity: 'Food or activity',
    weight_program_support_needs_option_other: 'Something else',
    weight_program_support_needs_option_ready_for_review: "I'm ready for doctor review",
    weight_program_support_needs_detail_label: 'Anything you want your doctor to know? (optional)',
    weight_program_decision_approved_title: 'You’re approved to start',
    weight_program_decision_alternative_title: 'Your doctor suggests another treatment',
    weight_program_decision_not_appropriate_title: 'Foundayo isn’t the right fit right now',
    weight_program_decision_status_approved: 'Approved',
    weight_program_decision_status_alternative: 'Alternative treatment',
    weight_program_decision_status_not_appropriate: 'Not appropriate',
    weight_program_decision_default_approved: 'Your doctor reviewed your answers and approved you to start Foundayo.',
    weight_program_decision_default_alternative:
      'Your doctor reviewed your answers and suggests a different treatment. They will talk with you about the next steps.',
    weight_program_decision_default_not_appropriate:
      'Your doctor reviewed your answers and decided that Foundayo is not the right option for you right now.',
    weight_program_decision_reviewed_by_label: 'Reviewed by',
    weight_program_decision_message_from: 'Message from Dr. {{doctor}}',
    weight_program_decision_message_from_dated: 'Message from Dr. {{doctor}} ({{date}})',
    weight_program_decision_message_from_your_doctor: 'Message from your doctor',
    weight_program_decision_doctor_name: 'Dr. {{doctor}}',
    weight_program_decision_start_again: 'Start again',
    weight_program_decision_status_awaiting_start: 'Awaiting start',
    weight_program_decision_medicine_label: 'Your medicine',
    weight_program_decision_prescription_label: 'Prescription',
    weight_program_decision_prescription_sent: 'Sent to your pharmacy',
    weight_program_decision_prescription_preparing: 'Your doctor is preparing it',
    weight_program_date_save: 'Save',
    weight_program_date_save_failed: 'We couldn’t save the date. Please try again.',
    weight_program_message_doctor: 'Message my doctor',
    weight_program_plan_note_from: 'Current plan (Dr. {{doctor}}, {{date}})',
    weight_program_weight_title: 'Your weight',
    weight_program_history_title: 'History',
    weight_program_history_invited: 'Invited to the program',
    weight_program_history_consents: 'Consents accepted',
    weight_program_history_form_sent: 'Health questions sent',
    weight_program_history_check_in_sent: 'Check-in sent',
    weight_program_history_plan_updated_by: 'Plan updated by Dr. {{doctor}}',
    weight_program_history_plan_updated: 'Plan updated',
    weight_program_history_first_dose: 'First tablet',
    weight_program_history_dose_start: 'Started new dose',
    weight_program_history_check_in_opened: 'Check-in opened',
    weight_program_history_check_in_missed: 'Check-in missed',
    weight_program_history_post_stop_check_in_sent: 'Check-in after stopping sent',
    weight_program_history_post_stop_check_in_opened: 'Check-in after stopping opened',
    weight_program_history_post_stop_check_in_missed: 'Check-in after stopping missed',
    weight_program_decision_type_approve_to_start: 'Approved to start',
    weight_program_decision_type_alternative_treatment: 'Alternative treatment',
    weight_program_decision_type_not_appropriate: 'Not appropriate',
    weight_program_decision_type_continue: 'Continue',
    weight_program_decision_type_new_prescription: 'New prescription',
    weight_program_decision_type_hold: 'Paused',
    weight_program_decision_type_stop: 'Stopped',
    weight_program_decision_type_continue_post_stop: 'Follow-up continues',
    weight_program_decision_type_close: 'Program closed',
    weight_program_first_dose_title: 'Tell us when you start',
    weight_program_first_dose_body:
      'Your monthly check-ins are scheduled from the day you take your first tablet, not from the prescription date. You can change the date until your first check-in opens.',
    weight_program_first_dose_label: 'Date of your first tablet',
    weight_program_first_dose_change_label:
      'Date of your first tablet (you can change it until your first check-in opens)',
    weight_program_dose_start_title: 'Your doctor updated your plan',
    weight_program_dose_start_decision_label: 'Decision',
    weight_program_dose_start_plan_label: 'New plan',
    weight_program_dose_start_form_title: 'Tell us when you switch',
    weight_program_dose_start_label: 'First day on {{medicine}}',
    weight_program_check_in_due_title: 'Time for your monthly check-in',
    weight_program_check_in_due_body:
      '10 short questions about your weight, your medicine and how you feel. Your doctor reviews every check-in, even when everything is fine.',
    weight_program_check_in_label: 'Check-in',
    weight_program_check_in_cycle: 'Cycle {{number}} · opened {{date}}',
    weight_program_plan_dose_label: 'Current dose',
    weight_program_plan_dose_since: '{{medicine}} since {{date}}',
    weight_program_check_in_last_weight_label: 'Last reported weight',
    weight_program_check_in_start: 'Start check-in',
    weight_program_check_in_help:
      'If you have a new problem before your next check-in, contact Tap in Chat rather than waiting for the monthly form.',
    weight_program_check_in_submitted_title: 'Thank you. Your update is with your doctor.',
    weight_program_check_in_submitted_body:
      'A Tap doctor will review it and tell you the next step. Your answers do not change your prescription.',
    weight_program_check_in_view_answers: 'View',
    weight_program_check_in_submitted_keep_taking:
      'Keep taking your medicine as prescribed until your doctor says otherwise. If you have a new problem before your next check-in, contact Tap in Chat.',
    weight_program_treatment_title: 'Your Foundayo plan',
    weight_program_on_hold_title: 'Your doctor paused the plan',
    weight_program_stopped_title: 'Your program ended',
    weight_program_status_on_treatment: 'On treatment',
    weight_program_status_on_hold: 'Paused by your doctor',
    weight_program_status_stopped: 'Stopped',
    weight_program_status_post_stop: 'Medicine stopped · follow-up',
    weight_program_post_stop_next_check_in: '{{date}} (check-in {{number}} of 2)',
    weight_program_post_stop_due_title: 'Time for a short check-in',
    weight_program_post_stop_due_body:
      '5 short questions about your weight and how you feel since you stopped Foundayo. Your doctor reviews every check-in.',
    weight_program_post_stop_check_in_value: '{{number}} of 2 · answer by {{date}}',
    weight_program_post_stop_stopped_label: 'Medicine stopped',
    weight_program_post_stop_help:
      'If you have a new problem, contact Tap in Chat rather than waiting for the check-in.',
    weight_program_post_stop_submitted_body: 'A Tap doctor will review it and tell you the next step.',
    weight_program_post_stop_eyebrow: 'Check-in after stopping',
    weight_program_post_stop_wellbeing_title: 'How do you feel since you stopped the medicine?',
    weight_program_post_stop_wellbeing_option_better: 'Better',
    weight_program_post_stop_wellbeing_option_same: 'About the same',
    weight_program_post_stop_wellbeing_option_worse: 'Worse',
    weight_program_post_stop_wellbeing_detail_label: 'What changed? (optional)',
    weight_program_post_stop_eating_title: 'Do you have any concern about your eating or appetite?',
    weight_program_post_stop_eating_option_none: 'No concern',
    weight_program_post_stop_eating_option_concerned: 'I am worried about my eating or appetite',
    weight_program_post_stop_eating_option_prefer_to_discuss: 'I prefer to discuss this',
    weight_program_post_stop_eating_detail_label: 'What worries you? (optional)',
    weight_program_post_stop_next_step_title: 'What would you like to do next?',
    weight_program_post_stop_next_step_option_fine: 'I am doing fine, nothing more is needed',
    weight_program_post_stop_next_step_option_talk_to_doctor: 'I want to talk to the doctor',
    weight_program_post_stop_next_step_option_return_to_treatment: 'I want to talk about starting the medicine again',
    weight_program_post_stop_next_step_detail_label: 'What would you like your doctor to know? (optional)',
    weight_program_next_check_in_paused: 'Paused, no check-in scheduled',
    weight_program_plan_dose_start_label: 'Taking this dose since',
    weight_program_plan_started_label: 'Started program',
    weight_program_plan_next_check_in_label: 'Next check-in',
    weight_program_monthly_eyebrow: 'Monthly check-in',
    weight_program_monthly_review_helper:
      'You can go back and change anything before sending. After sending, your doctor reviews these answers; changes go through Chat.',
    weight_program_monthly_problem_weight_incomplete: 'Please fill in your weight, the unit and the date.',
    weight_program_monthly_weight_title: 'What is your weight today?',
    weight_program_monthly_weight_helper: 'Use a recent measured value.',
    weight_program_monthly_weight_helper_previous:
      'Use a recent measured value. Last time you reported {{weight}} on {{date}}.',
    weight_program_monthly_weight_label: 'Weight today',
    weight_program_monthly_dose_match_title: 'Does this match what you are taking?',
    weight_program_monthly_dose_match_helper: 'Your chart shows {{medicine}} daily, started {{date}}.',
    weight_program_monthly_dose_match_helper_no_date: 'Your chart shows {{medicine}} daily.',
    weight_program_monthly_dose_match_option_same: 'Yes, the dose and date are right',
    weight_program_monthly_dose_match_option_different: 'The dose or start date is different',
    weight_program_monthly_dose_match_option_stopped: 'I stopped taking it',
    weight_program_monthly_dose_match_option_not_started: 'I have not started',
    weight_program_monthly_dose_match_detail_label: 'Your actual dose, start date, or last dose date (if known)',
    weight_program_monthly_missed_days_title: 'How many days did you miss this month?',
    weight_program_monthly_missed_days_helper: 'About right is fine if you do not remember exactly.',
    weight_program_monthly_missed_days_label: 'Total days missed this month',
    weight_program_monthly_missed_days_in_a_row_label: 'Most days missed in a row',
    weight_program_monthly_missed_days_summary: '{{count}} days total, {{inARow}} in a row',
    weight_program_monthly_appetite_title: 'How is the medicine helping with hunger and cravings?',
    weight_program_monthly_appetite_option_helping: 'It helps, and I can still eat regular meals',
    weight_program_monthly_appetite_option_still_hungry: 'Hunger or cravings are still hard to manage',
    weight_program_monthly_appetite_option_little_appetite: 'I have so little appetite that eating is hard',
    weight_program_monthly_appetite_option_no_change: 'I have not noticed a change',
    weight_program_monthly_side_effects_title: 'How much have side effects bothered you?',
    weight_program_monthly_side_effects_helper:
      'For example: nausea, vomiting, diarrhea, constipation, or other new symptoms.',
    weight_program_monthly_side_effects_option_none: 'Not at all',
    weight_program_monthly_side_effects_option_mild: 'Mild, and I can do my usual activities',
    weight_program_monthly_side_effects_option_interfere: 'They affect my eating or daily activities',
    weight_program_monthly_side_effects_option_severe: 'They are severe',
    weight_program_monthly_side_effects_detail_label: 'What side effect, and how often? (if known)',
    weight_program_monthly_eating_and_fluids_title: 'How are eating, drinking, and daily activities going?',
    weight_program_monthly_eating_and_fluids_option_usual: 'I can eat, drink, and do my usual activities',
    weight_program_monthly_eating_and_fluids_option_hard_to_eat: 'It is hard to eat regular meals',
    weight_program_monthly_eating_and_fluids_option_hard_to_drink: 'I have trouble drinking enough',
    weight_program_monthly_eating_and_fluids_option_cannot_keep_fluids: 'I cannot keep fluids down',
    weight_program_monthly_eating_and_fluids_option_less_urine: 'I am urinating much less',
    weight_program_monthly_eating_and_fluids_option_weaker: 'I feel weaker or daily tasks are harder',
    weight_program_monthly_warning_signs_title: 'Have you had any of these warning signs?',
    weight_program_monthly_warning_signs_helper:
      'Choose all that apply. Get help now for an emergency; do not wait to finish.',
    weight_program_monthly_warning_signs_option_persistent_belly_pain: 'Strong belly pain that does not go away',
    weight_program_monthly_warning_signs_option_yellow_skin_or_eyes: 'Yellow skin or eyes',
    weight_program_monthly_warning_signs_option_vision_trouble: 'New vision trouble',
    weight_program_monthly_warning_signs_option_neck_lump_or_hoarse: 'A neck lump or a hoarse voice that lasts',
    weight_program_monthly_warning_signs_option_face_or_tongue_swelling: 'Swelling of my face or tongue',
    weight_program_monthly_warning_signs_option_trouble_breathing: 'Trouble breathing',
    weight_program_monthly_warning_signs_option_low_blood_sugar:
      'Low blood sugar, shaking, sweating, faintness, or confusion',
    weight_program_monthly_warning_signs_detail_label: 'When did it happen, and what did you notice? (optional)',
    weight_program_monthly_changes_title: 'Has any of this changed since your last check-in?',
    weight_program_monthly_changes_option_medicines: 'New, stopped, or changed medicines or supplements',
    weight_program_monthly_changes_option_health: 'A new health problem or something else',
    weight_program_monthly_changes_option_pregnant: 'I am pregnant or might be pregnant',
    weight_program_monthly_changes_option_planning_pregnancy: 'I plan to become pregnant',
    weight_program_monthly_changes_option_breastfeeding: 'I am breastfeeding',
    weight_program_monthly_changes_option_birth_control_pills: 'Birth-control pills',
    weight_program_monthly_changes_option_periods_changed: 'My periods stopped or changed in a way I cannot explain',
    weight_program_monthly_changes_option_procedure_planned: 'Surgery or anesthesia is planned',
    weight_program_monthly_changes_option_none: 'No changes',
    weight_program_monthly_changes_detail_label: 'Tell your doctor a little more (optional)',
    weight_program_monthly_changes_reported_title: 'Medicines you listed before',
    weight_program_monthly_changes_reported_helper:
      'This is what you told us last time. If something changed, choose the first option below and update the list.',
    weight_program_monthly_changes_medications_label: 'Your medicines and supplements now (required)',
    weight_program_monthly_changes_medications_helper:
      'We filled in your last list. Add, remove or change what is different now.',
    weight_program_monthly_changes_medications_summary: 'Medicines now: {{list}}',
    weight_program_monthly_eating_concerns_title: 'Have any of these happened this month?',
    weight_program_monthly_eating_concerns_helper:
      'Choose all that apply. We ask everyone so we can support safe treatment.',
    weight_program_monthly_eating_concerns_option_restricting_from_fear: 'I skip food because I fear gaining weight',
    weight_program_monthly_eating_concerns_option_purging_or_compensating:
      'I vomit, use laxatives or water pills, or exercise to undo eating',
    weight_program_monthly_eating_concerns_option_loss_of_control_eating: 'I feel unable to stop eating at times',
    weight_program_monthly_eating_concerns_option_worries_interfere:
      'Worries about food or weight get in the way of daily life',
    weight_program_monthly_eating_concerns_option_dose_change_upsetting:
      'Lowering or stopping the medicine feels very upsetting',
    weight_program_monthly_eating_concerns_option_took_extra: 'I took more medicine than prescribed',
    weight_program_monthly_eating_concerns_option_other_source: 'I used weight medicine from another source',
    weight_program_monthly_eating_concerns_option_prefer_to_discuss: 'I would rather talk with my clinician',
    weight_program_monthly_eating_concerns_detail_label: 'Anything you want to share? (optional)',
    weight_program_monthly_plan_preference_title: 'What would you like to discuss about your plan?',
    weight_program_monthly_plan_preference_helper: 'Choose all that apply. Your answer does not change your dose.',
    weight_program_monthly_plan_preference_option_continue: 'Keep the current plan',
    weight_program_monthly_plan_preference_option_increase: 'More help toward my goal or a higher dose',
    weight_program_monthly_plan_preference_option_decrease: 'A lower dose or help with side effects',
    weight_program_monthly_plan_preference_option_maintain: 'I am near or in my goal range and want to maintain it',
    weight_program_monthly_plan_preference_option_losing_too_much: 'I am losing more weight than I want',
    weight_program_monthly_plan_preference_option_need_goal: 'I need help setting a goal',
    weight_program_monthly_plan_preference_option_stop: 'Stopping medicine or moving care',
    weight_program_monthly_plan_preference_option_cost_or_access: 'Cost or getting my medicine',
    weight_program_monthly_plan_preference_option_question: 'Another question',
    weight_program_monthly_plan_preference_detail_label: 'What would you like your doctor to know? (optional)',

    // Phone-first auth
    phone_auth_error_generic: 'Something went wrong. Please try again.',
    google_sign_in_error: 'Failed to connect to the Google authentication service. Please try again.',
    profile_updated_success: 'Profile updated successfully!',
    phone_auth_error_rate_limited: 'Too many attempts, try again in a few minutes.',
    phone_auth_error_session_expired: 'Your sign-up session expired. Please start again.',
    phone_auth_error_code_invalid: 'That code is not correct. Please check it and try again.',
    phone_auth_error_code_expired: 'That code has expired. Please request a new one.',
    phone_auth_error_code_send_failed: 'We could not send the code. Please try again.',
    phone_auth_error_patient_required: 'This account has no patient record yet.',
    phone_auth_error_email_not_verified: 'Please confirm your email first.',
    phone_auth_error_patient_not_allowed: 'This record is not available for this number.',
    phone_auth_error_already_claimed: 'This record is already linked to an account. Please sign in.',
    phone_auth_error_already_registered: 'You are already registered. Please sign in.',
    phone_auth_error_already_confirmed: 'This number is already confirmed.',
    phone_auth_error_dob_required: 'Please enter your date of birth.',
    phone_auth_error_dob_mismatch:
      'The date of birth you entered does not match our records. Please text us from this phone and a provider will check your details.',
    phone_auth_error_dob_attempts_exceeded:
      'Too many incorrect attempts. Wait 20 minutes and try again, or text us from this phone and a provider will check your details.',
    phone_auth_error_must_be_adult: 'You must be at least 18 years old to create an account.',
    phone_auth_error_hipaa_required: 'Please accept the privacy agreement to continue.',
    phone_auth_error_terms_required: 'Please accept the Terms of Use and Privacy Policy to continue.',
    phone_auth_error_same_number: 'This is your own number. Enter the other adult’s own phone number.',
    phone_auth_error_phone_required: 'Please enter a phone number.',
    phone_auth_error_number_has_account: 'This number already belongs to an account. Please use another number.',
    phone_auth_error_register_by_phone:
      'There is no account for this Google email. Register with your phone number first.',
    phone_auth_invalid_phone: 'Enter a valid US phone number.',
    phone_auth_code_sent_to: 'Enter the 6-digit code sent to {{target}}.',
    phone_auth_resend: 'Send a new code',
    phone_auth_resend_wait: 'Send a new code ({{seconds}}s)',
    phone_auth_change_number: 'Use another number',
    phone_auth_change_email: 'Use another email',
    phone_auth_verify_title: 'Verify your phone number',
    phone_auth_login_title: 'Sign in',
    phone_auth_login_subtitle: 'Enter your phone number. We will send a one-time code by SMS.',
    phone_auth_use_email_instead: 'Sign in with your email instead',
    phone_auth_use_phone_instead: 'Sign in with your phone number instead',
    phone_auth_email_login_title: 'Sign in with your email',
    phone_auth_email_login_subtitle: 'We will send a one-time code to your email address.',
    phone_auth_check_email: 'Check your email',
    phone_auth_email_code_hint:
      'If this email is linked to an account, we sent a code. The code is valid for 10 minutes. Enter it below.',
    phone_auth_no_account_continue_phone: 'No account yet? Continue with your phone number',
    phone_auth_no_account_title: 'No account yet',
    phone_auth_no_account_text:
      'Your number is verified, but there is no account for it. You can create your patient profile now. It takes about a minute.',
    phone_auth_create_profile: 'Create my profile',
    phone_auth_create_account: 'Create your account',
    phone_auth_register_title: 'Create your account',
    phone_auth_register_subtitle: 'Enter your phone number. We will send a one-time code by SMS. No password needed.',
    phone_auth_sign_in: 'Sign in',
    phone_auth_account_exists_title: 'You already have an account',
    phone_auth_account_exists_text: 'This number is linked to an existing account, so we signed you in.',
    phone_auth_choose_title: 'Which record is yours?',
    phone_auth_choose_subtitle:
      'Several people use this number. Choose yourself. We only show a short name and birth year.',
    phone_auth_choose_none: 'I’m not on this list, add me',
    phone_auth_choose_hint:
      'Don’t recognise someone on this list? Please text us from this phone so we can check the number.',
    phone_auth_found_title: 'We found your patient record',
    phone_auth_found_subtitle: 'Your care history will be connected to this account. Confirm your details to continue.',
    phone_auth_profile_title: 'Create your patient profile',
    phone_auth_profile_subtitle: 'We couldn’t find an existing patient record for this phone number.',
    phone_auth_add_email_title: 'Add your email',
    phone_auth_email_hint:
      'We have an email on file ending in {{hint}}. Enter it to receive the code, or use another email.',
    phone_auth_add_email_subtitle: 'Your email is the backup way to sign in if you lose access to your phone number.',
    phone_auth_heard_title: 'One last question',
    phone_auth_finish: 'Finish',
    phone_auth_skip: 'Skip',
    phone_auth_profile_ready: 'Your profile is ready',
    phone_auth_invitation_invalid: 'This invitation link is not valid.',
    phone_auth_invitation_invalid_title: 'This invitation link is no longer valid',
    phone_auth_invitation_invalid_text:
      'It was already used or has expired. If you already set up your account, sign in with your phone number. Otherwise ask your provider for a new invitation.',
    phone_auth_invitation_title: 'Confirm your phone number',
    phone_auth_invitation_hint: 'We will send a code to the phone number on your record ending in {{hint}}.',
    phone_auth_invitation_another_number: 'That’s not my number anymore',
    phone_auth_invitation_other_number: 'Enter the phone number you want to use. We will send a one-time code by SMS.',
    phone_auth_invitation_no_number:
      'There is no phone number on your record. Enter yours and we will send a one-time code by SMS.',
    phone_auth_invitation_use_record_number: 'Use the number on my record',
    phone_auth_claim_invalid_link: 'This link is not valid.',
    phone_auth_claim_hello: 'Hello, {{name}}',
    phone_auth_claim_subtitle: 'Confirm the phone number ending in {{hint}}. It will be used only for you.',
    phone_auth_claim_confirm: 'Confirm',
    phone_auth_claim_done_title: 'Thanks, your number is confirmed',
    phone_auth_claim_done_text: 'You can now sign in to the Patient Portal with this number.',
    phone_auth_claim_already_used: 'This link was already used.',
    phone_auth_add_phone_title: 'Add your phone number',
    phone_auth_add_phone_text: 'Enter your phone number. We will send a one-time code by SMS.',
    phone_auth_add_phone_banner:
      'Your account has no verified phone number yet. Add it to sign in faster next time and so we can text you about your care.',
    phone_auth_add_phone_cta: 'Add number',
    phone_auth_add_phone_done: 'Your phone number is verified',
    phone_auth_shared_title: 'Other adults in your household share this number',
    phone_auth_shared_text:
      'Each adult needs their own number so we can keep their care private. Enter their phone number and we will text them a link to confirm it.',
    phone_auth_shared_cta: 'Enter their number',
    phone_auth_became_adult: '{{name}} is now an adult',
    phone_auth_their_number: 'Their phone number',
    phone_auth_send_link: 'Send link',
    phone_auth_has_login_note: 'This record already has an account. Confirm your date of birth to sign in.',
    phone_auth_link_sent: 'Link sent',
    // Google connect
    phone_auth_error_google_state_invalid: 'This Google confirmation expired or was already used. Please try again.',
    phone_auth_error_google_state_forbidden:
      'This Google confirmation does not belong to your current session. Please try again.',
    phone_auth_error_google_email_unverified: 'Google has not verified this email address. Use another Google account.',
    phone_auth_error_google_account_in_use: 'This Google account is already connected to another login.',
    phone_auth_google_confirm: 'Confirm with Google',
    google_cancelled: 'Google sign-in was cancelled',
    google_session_missing: 'Sign in and try again.',
    google_connected_success: 'Google account connected',
    google_email_changed_success: 'Your sign-in email was updated',
    signin_methods_load_error: 'We could not load your sign-in methods. Please try again later.',
    signin_methods_title: 'Sign-in methods',
    signin_methods_phone: 'Phone number',
    signin_methods_email: 'Email',
    signin_methods_google: 'Google',
    signin_methods_verified: 'Verified',
    signin_methods_not_confirmed: 'Not confirmed',
    signin_methods_not_verified: 'Not verified',
    signin_methods_connected: 'Connected',
    signin_methods_not_connected: 'Not connected',
    signin_methods_connected_since: 'since {{date}}',
    signin_methods_google_default: 'Works with the email of your account',
    signin_methods_use_other_google: 'Use another Google account',
    signin_methods_connect_google: 'Connect Google',
    signin_methods_not_set: 'Not set',
    google_email_change_title: 'Change sign-in email',
    google_email_change_text: 'Your sign-in email will change from {{old}} to {{new}}. Continue?',
  },
}
